var _style, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _polyline, _polyline2, _polyline3, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMixedOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    style: {
      enableBackground: "new 0 0 720 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);stroke:url(#SVGID_00000147906910775635222970000014087469484026669460_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000093882413673467038010000017011325810823739560_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000162347507939677626770000002419976781418504845_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000140696882776146760870000014625195064730939268_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000011008252741298016460000006637506542370933430_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000141452344407359626460000015637993726727939262_);}\n\t\n\t\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173870572746853076220000016974742345309541252_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000018957746549192932730000007411397311719021973_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000041265034297557268210000003124432885556647354_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000064318100768368851240000016286331227269063830_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000156589739684777854830000005054527955741162370_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000143602158274327555730000006047382741924485532_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000049200977403008114000000015073927377420347013_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000169537206921403896340000008231293330903802021_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000060724264383372419140000009538926433475570359_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000023988545980271328150000011767643615987927186_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000067205629680315027880000006609311033989352843_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000034785153602355727840000005652502013631036813_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000119807018324127163800000017300006746755143606_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000096034227358510493650000015794292078335035521_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000116923852113529165430000006619329636596588702_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000047058418581497404300000011070926200152779437_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000156569583781023446410000002186386543494663305_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000142876783028495884990000002734486855366790075_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000147914541435338564150000016121784691880025248_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000163036272326647635100000008427998202147037363_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000004505156039192202920000003933638392413057154_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000147922099378287726420000016610841031807817907_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000062175277745034767640000006585424551210282883_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000088849330960209779730000001077032948987945640_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000018926922528203497470000000316226963934680215_);stroke:url(#SVGID_00000116952257781777144020000004426330162726447016_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173859296654083968690000003517371525104849822_);stroke:url(#SVGID_00000085228627837507283830000016897894589460867254_);stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t\n\t\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000083049788092698147140000003684285069912669113_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000072265730759536144570000013677629303743875207_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000080915220209087065020000017282807102250875027_);stroke:#FFFFFF;stroke-width:4.7999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000180331529642619247710000014933892665958986385_);stroke:url(#SVGID_00000018932926529119686780000005909879971955034777_);stroke-width:2.8797;stroke-miterlimit:22.9256;}\n\t\n\t\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000054965409927036390360000005066492890803103908_);stroke:url(#SVGID_00000106835763953991103570000006030529858512422804_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000157290958608392807100000013709988989780323244_);stroke:url(#SVGID_00000138572131870290718240000010330275655115480992_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000150095867033350420020000011925358445800077475_);stroke:url(#SVGID_00000024716412043278025550000018202773358571974331_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000074418798729822275270000015497829503373505718_);stroke:url(#SVGID_00000174562392664386415170000010963467777945945475_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000052067974864542182940000012378853285297764029_);stroke:url(#SVGID_00000043458293385812321330000008212141510261724300_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000030460619074591337580000002064260808019056018_);stroke:url(#SVGID_00000178177994718204902200000008645312989942242466_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000142876000508629461830000008341454394505227409_);stroke:url(#SVGID_00000093897810919476139940000002750764889631056297_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000127740206509002069460000014061116402038895254_);stroke:url(#SVGID_00000033330299911006063950000014624823997942045868_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000053545632518349713230000006495557042989109434_);stroke:url(#SVGID_00000156581940265738045140000015592526025976017046_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000139997942508757882300000016072625092234637961_);stroke:url(#SVGID_00000166661510361157907830000003798227612096652177_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000036225249446344597110000001780788997372202164_);stroke:url(#SVGID_00000095331751591334554610000005857399872101405614_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:#000002;stroke:url(#SVGID_00000101104619882128380670000015373542574693952168_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:#000002;stroke:url(#SVGID_00000003790208865228562940000008512421100780548271_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000020363414416424502470000012678950567706177721_);stroke:url(#SVGID_00000054961873748353898080000007299709261676805786_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:#000002;stroke:url(#SVGID_00000122680548004051749970000001548133445053975182_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st51{fill-rule:evenodd;clip-rule:evenodd;stroke:url(#SVGID_00000055709068273381695550000013240722795983871627_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st52{fill-rule:evenodd;clip-rule:evenodd;stroke:url(#SVGID_00000031203033883877999310000018260295754244897711_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000058569568321657516860000007300136818110452637_);}\n\t.st54{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000129196179242105624470000012694514846509648043_);}\n\t.st55{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000112599382796721018130000002321575041815513016_);}\n\t\n\t\t.st56{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000010291212191916955910000007825570953472812186_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st57{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FBB378;stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t.st58{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000132086809054229745710000001384661947202599809_);}\n\t\n\t\t.st59{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000032630506033022301540000002050621474187766184_);stroke:url(#SVGID_00000016061366379931532970000015863451719095959194_);stroke-miterlimit:10;}\n\t.st60{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000164499835197638792770000005925807991889202581_);}\n\t.st61{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000183932509869007742850000012213309785146724247_);}\n\t\n\t\t.st62{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000015336809354624064850000006137868282450777750_);stroke:url(#SVGID_00000064337045264162715840000007915699370677145776_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st63{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000083773068280099683780000014473611495976508549_);stroke:#2B3087;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st64{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000072965953237201020450000013352475579308127626_);}\n\t\n\t\t.st65{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000007427711111878269110000012212946821678951584_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st66{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000085972502237668490310000007987213848622920068_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st67{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000093174199736108771690000010710144634000899997_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st68{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000148620388459639813570000003161276195673206455_);stroke:url(#SVGID_00000022533126879472883710000000560220832123766206_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st69{fill-rule:evenodd;clip-rule:evenodd;fill:#98C03D;stroke:url(#SVGID_00000008125343885563137580000015402900846222173358_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st70{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000059267700658053764050000010557798388745312920_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t.st71{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st72{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000036210026209251693450000012191937798061172887_);stroke:url(#SVGID_00000049906461144291375960000008602707826757280423_);stroke-width:1.9199;stroke-miterlimit:22.9256;}\n\t\n\t\t.st73{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000155119367839978039250000001847754451167563946_);stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st74{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000086690706834496116960000004615197613960679578_);stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st75{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000052782203453898095460000014674994514166237609_);stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st76{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000105399410794101762840000012606256603128451493_);stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st77{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000016770090118232627770000013794665729834076836_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st78{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000098925723539044051050000003981817545736958349_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st79{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000014605898080347796300000002482479603238942626_);stroke:#000002;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t.st80{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st81{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000019640286033146908230000004130292743265943187_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st82{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000165933618387766742050000015320273529058619539_);stroke:url(#SVGID_00000031195374611704061890000002259992646987368865_);stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t\n\t\t.st83{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000135688075062058280810000015400227743904415361_);stroke:url(#SVGID_00000024709767262060942570000010335404325339485371_);stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t\n\t\t.st84{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000003795212704805167350000011618570077177890728_);stroke:url(#SVGID_00000176753770086613165820000015021341060629164448_);stroke-width:2.3998;stroke-miterlimit:22.9256;}\n\t.st85{fill-rule:evenodd;clip-rule:evenodd;fill:#44459C;}\n\t\n\t\t.st86{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000084488580454726446250000004988937421060054441_);stroke:url(#SVGID_00000131334582640511703190000018380397929702840470_);stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st87{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000005976119214059321300000014374750202872126895_);stroke:url(#SVGID_00000118357746260243444250000005586856953274839483_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st88{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000137110503813920901610000015927589780415469230_);stroke:url(#SVGID_00000093173872573899633690000004667501009954670238_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st89{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000181055391383934226810000018443056653359532678_);stroke:url(#SVGID_00000085950669067855019350000010371137682973239961_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st90{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000014607833545925911750000010632256447777913746_);stroke:url(#SVGID_00000030465256835371776310000002519603913285222590_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st91{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000163774928201799112940000012448668690796682113_);stroke:url(#SVGID_00000032620263619789757210000001410102584506202254_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st92{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000154418303527781227360000014122169737971427241_);stroke:url(#SVGID_00000148649689578153493000000002112276633763613837_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st93{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000034799266147814942410000005600746429059219091_);stroke:url(#SVGID_00000118375492274792164940000010397642347549022883_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st94{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000052066849331544446320000011063537626874931357_);stroke:url(#SVGID_00000132055547647719228210000001534283431621951926_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st95{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000075841839540753580750000003506966193308683709_);stroke:url(#SVGID_00000078737786428084528420000006740274844149822088_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st96{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000045614332794189960740000007453770972642517400_);stroke:url(#SVGID_00000162330283535330235080000011318015996684321450_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t.st97{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000176011076814014133380000017198214480240833721_);}\n\t.st98{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000020362103655960140060000012161617315210740660_);}\n\t.st99{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000009554246793172748100000010140782439281399230_);}\n\t.st100{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000145053196704255344240000004289416261738856610_);}\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000170979564635866012790000001199098658949910685_);}\n\t.st102{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t\n\t\t.st103{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000139986139916475551350000006893995489976103556_);stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st104{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000054240239087830073790000008877643541951447971_);stroke:#000000;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st105{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000127726963012156949790000005535465384083529147_);stroke:#FFFFFF;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st106{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000124869227553573546670000013006201340656366245_);stroke:#FFFFFF;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st107{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000036243106904171719990000013185081941141213351_);stroke:#FFFFFF;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st108{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000098218119910874548920000000297090463251767482_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st109{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000163052182881677025590000012510676684442906809_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st110{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000077286240086502995150000009390600800109860022_);stroke:#FFFFFF;stroke-width:0.5669;stroke-miterlimit:22.9256;}\n\t\n\t\t.st111{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000055668176738603472740000004468830775932357280_);stroke:#FFFFFF;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st112{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000052803760681470326340000004208738599579248565_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st113{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000162342539407204947790000016548362370591726244_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st114{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000145051764607604372850000005130216051293514885_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st115{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000147908040169945775370000009761618314382656686_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st116{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000094610114165907155870000009936033485628432311_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st117{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000119805138136011301480000012399576649684445865_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st118{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000029751039438770862950000018165960522712402111_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st119{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000124867517782920692300000006363637161955694979_);stroke:#FFFFFF;stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st120{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000127008113770722118940000009132055013337577380_);stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st121{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000155862163012733882110000000955278465040338611_);stroke:#000000;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t.st122{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000178162445413235839980000006633198720971700406_);}\n\t.st123{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000026139698094405586210000018311173465024825279_);}\n\t.st124{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000122694559733732951570000014721329709606847408_);}\n\t.st125{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000147184384218095242380000017143734264684370312_);}\n\t.st126{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000111153636738724805440000004513372147653752764_);}\n\t.st127{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000111179870223511301410000008082875800608776593_);}\n\t\n\t\t.st128{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000089569645709451819360000010071428230354083470_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st129{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000029756267630786491080000017238367335416111271_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st130{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000121981071677479159950000017603435776712565176_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t\n\t\t.st131{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000087386053574511865640000000359175677841275303_);stroke:#000002;stroke-width:1.1999;stroke-miterlimit:22.9256;}\n\t.st132{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000166657943162220682300000016308714866748275884_);}\n\t.st133{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000159448423186302197920000008563530747824650681_);}\n\t.st134{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000003813254062377619110000012698544483797704864_);}\n\t.st135{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000160869362558931908090000010543378139149414566_);}\n\t.st136{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000000904282580681346100000001325762009782591666_);}\n\t.st137{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000111153810333750187710000001036193940587593388_);}\n\t.st138{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000093871054182876862620000012015245288554435766_);}\n\t.st139{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000177456648034385718060000003948726570597829762_);}\n\t.st140{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000171683830343578113060000009609437838506373277_);}\n\t.st141{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000140692848847331232260000009322462802195015828_);}\n\t.st142{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000029012890981020198050000013194704243914093499_);}\n\t\n\t\t.st143{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000166650594870766709530000017431047523512344757_);stroke:url(#SVGID_00000096036077464311585140000008491673495555890583_);stroke-miterlimit:10;}\n\t.st144{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000135651502775160101440000014536022761780069013_);}\n\t.st145{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000053523169575603203920000007397417594322110849_);}\n\t.st146{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000175287267849392858430000012941526621716866463_);}\n\t.st147{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173870003777604301140000018332001232537882763_);}\n\t.st148{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000013191556922806041320000011280254175844904592_);}\n\t.st149{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000090259101138499138510000013468345336956262541_);}\n\t\n\t\t.st150{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000135660834926711912990000006969608264167202947_);stroke:#35459C;stroke-miterlimit:22.9256;}\n\t.st151{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000109017947103855267600000012401611375159702425_);}\n\t.st152{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000152946784511053475620000014346216972903119790_);}\n\t.st153{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000011733758650325529700000003889459563754871457_);}\n\t.st154{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000022526874795251816160000018404988049960420284_);}\n\t.st155{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000005964583262130554690000013818896939995109007_);}\n\t.st156{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000057835479461376181290000012669319286323121051_);}\n\t\n\t\t.st157{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000076606190196869508570000011901653755808726695_);stroke:url(#SVGID_00000181804516029385286010000005297022117161558201_);stroke-width:0.9361;stroke-miterlimit:10;}\n\t\n\t\t.st158{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000072997319105662191210000001797081732686991027_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st159{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000096020415042786169320000007209886222279344820_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st160{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000133515118233901191680000015476265711917847985_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n\t\n\t\t.st161{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:url(#SVGID_00000068662774391231774350000000140007771759830411_);stroke-width:0.9598;stroke-miterlimit:22.9256;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.1062,
    y1: 89.4184,
    x2: 378.6171,
    y2: 89.4184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73CBF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3715,
    style: {
      stopColor: "#0D1229"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    style: {
      stopColor: "#E0E31C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    style: {
      stopColor: "#E9F0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    style: {
      stopColor: "#0C0C0C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079474587971918368960000000088377568675952027_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.8227,
    y1: 89.4184,
    x2: 378.9006,
    y2: 89.4184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#455AA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_1_)",
      stroke: "url(#SVGID_00000079474587971918368960000000088377568675952027_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    cx: 341.36,
    cy: 89.42,
    r: 37.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041284164851218701390000005088724967547473819_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.6183,
    y1: 72.9189,
    x2: 378.509,
    y2: 72.9189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#F99D1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5369,
    style: {
      stopColor: "#F4EE6E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000041284164851218701390000005088724967547473819_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M334.6,53.41c-0.62,0.72-1.35,2.08-1.67,3.48c-0.32,1.39-0.22,2.81,0.05,3.88c0.27,1.07,0.72,1.79,0.74,2.34 c0.02,0.56-0.39,0.95-1.35,1.36c-0.96,0.41-2.48,0.85-4.3,1.42c-1.82,0.57-3.93,1.27-5.64,1.98c-1.71,0.71-3.02,1.43-3.54,2.08 c-0.52,0.65-0.25,1.25,0.28,1.55c0.53,0.3,1.34,0.32,1.7,0.57c0.37,0.25,0.3,0.75,0.2,1.56c-0.09,0.82-0.2,1.96,0.07,3.03 c0.27,1.07,0.94,2.07,1.46,2.77c0.53,0.7,0.92,1.11,1.17,1.63c0.25,0.51,0.37,1.13,0.59,1.49c0.23,0.36,0.56,0.46,1.01,0.3 c0.45-0.16,1.01-0.58,1.21-1.26c0.2-0.68,0.03-1.6-0.03-2.39c-0.06-0.79-0.02-1.44-0.08-2.22c-0.06-0.79-0.23-1.72-0.03-2.39 c0.2-0.68,0.76-1.1,1.4-1.53c0.64-0.44,1.36-0.89,1.66-1.42c0.3-0.53,0.19-1.15,0.6-1.55c0.41-0.39,1.34-0.56,2.05-0.13 c0.72,0.43,1.22,1.46,1.9,2.53c0.68,1.08,1.52,2.2,2.22,2.96c0.7,0.75,1.24,1.13,1.77,1.84c0.53,0.7,1.03,1.73,1.31,2.8 c0.27,1.07,0.32,2.18,1.07,3.24c0.75,1.06,2.22,2.08,2.79,3.01c0.57,0.94,0.25,1.79-0.42,2.55c-0.66,0.76-1.66,1.42-1.99,2.28 c-0.32,0.86,0.03,1.91,0.56,2.22c0.53,0.3,1.25-0.15,2.06-1.01c0.8-0.87,1.69-2.15,2.75-2.9c1.06-0.75,2.3-0.98,3.2-1.78 c0.89-0.8,1.44-2.18,1.79-3.36c0.35-1.18,0.49-2.17,0.94-3.21c0.45-1.04,1.21-2.14,2.32-3.06c1.11-0.92,2.58-1.67,3.87-2.46 c1.3-0.79,2.42-1.64,3.24-2.43c0.82-0.79,1.32-1.52,2.19-1.6c0.87-0.08,2.09,0.5,2.86,1.24c0.77,0.74,1.1,1.64,1.67,3.06 c0.58,1.41,1.41,3.34,2.26,4.55c0.86,1.2,1.74,1.68,2.41,2.68c0.66,1,1.1,2.52,1.75,3.92c0.65,1.4,1.53,2.68,2.18,3.7 c0.66,1.02,1.1,1.78,1.36,1.51c0.25-0.27,0.32-1.56,0.25-3.31c-0.07-1.75-0.27-3.95-0.63-6.04c-0.36-2.09-0.89-4.06-1.67-6.14 c-0.78-2.08-1.81-4.26-2.98-6.25c-1.17-2-2.49-3.81-3.93-5.46c-1.44-1.65-2.99-3.14-4.84-4.58c-1.85-1.44-4.01-2.84-6.14-3.96 c-2.13-1.12-4.23-1.96-6.22-2.58c-1.99-0.62-3.85-1.02-6.1-1.26c-2.24-0.24-4.87-0.31-6.55-0.3c-1.68,0-2.43,0.09-3.06,0.17 C335.73,52.6,335.22,52.69,334.6,53.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155861958948133720340000004061911690810863508_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.2721,
    y1: 82.9898,
    x2: 315.5806,
    y2: 82.9898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#A91E22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8676,
    style: {
      stopColor: "#F4EE6E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000155861958948133720340000004061911690810863508_)"
    },
    d: " M315.31,63.75c0.23,0.72,0.38,2.5,0.17,4.48c-0.21,1.98-0.77,4.16-1.11,6.3c-0.33,2.14-0.43,4.24-0.32,5.74 c0.11,1.5,0.44,2.4,0.32,3.54c-0.11,1.14-0.66,2.52-1.2,3.5c-0.54,0.98-1.08,1.55-1.32,2.4c-0.25,0.84-0.21,1.96-0.06,2.73 c0.14,0.77,0.38,1.21,0.49,1.83c0.11,0.62,0.1,1.42-0.14,2.34c-0.23,0.92-0.68,1.96-1.25,2.79c-0.57,0.82-1.26,1.43-1.96,2.06 c-0.69,0.64-1.39,1.3-1.91,1.17c-0.52-0.13-0.85-1.05-1.2-2.28c-0.35-1.23-0.73-2.76-1.02-4.69c-0.29-1.93-0.49-4.26-0.52-6.29 c-0.03-2.03,0.1-3.77,0.35-5.44c0.24-1.67,0.6-3.28,1.1-4.96c0.51-1.68,1.17-3.44,1.99-5.19c0.82-1.75,1.8-3.49,2.69-4.88 c0.89-1.39,1.69-2.45,2.34-3.26c0.65-0.81,1.16-1.38,1.58-1.83C314.75,63.36,315.08,63.03,315.31,63.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176725922313929943370000004657857313703064450_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.12,
    y1: 108.4328,
    x2: 377.2887,
    y2: 108.4328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000176725922313929943370000004657857313703064450_)"
    },
    d: " M316.18,115.89c0.26-0.71,1.45-1.52,2.22-2.28c0.77-0.76,1.12-1.46,1.43-2.4c0.31-0.94,0.58-2.1,0.7-3.17 c0.13-1.06,0.11-2.02,0.11-2.9c0-0.88,0.01-1.68,0.25-2.12c0.24-0.44,0.7-0.53,1.4-0.65c0.7-0.13,1.63-0.29,2.84-0.67 c1.21-0.38,2.7-0.97,3.63-1.14c0.93-0.17,1.3,0.08,1.69,0.49c0.39,0.41,0.82,0.97,1.51,1.25c0.69,0.27,1.65,0.26,3.07,0.16 c1.42-0.1,3.31-0.28,4.57-0.83c1.26-0.55,1.89-1.46,2.6-1.99c0.7-0.53,1.48-0.67,2.2-1.12c0.72-0.45,1.38-1.21,1.72-1.99 c0.34-0.78,0.35-1.58,0.81-2.15c0.46-0.56,1.36-0.89,2.01-1.25c0.65-0.36,1.06-0.75,1.44-1.3c0.38-0.55,0.73-1.25,1.43-1.38 c0.7-0.13,1.74,0.32,2.98,0.58c1.25,0.25,2.7,0.31,3.9,0.33c1.2,0.02,2.16,0.01,3.08,0.24c0.92,0.23,1.81,0.71,2.55,1.3 c0.75,0.58,1.35,1.27,1.91,1.73c0.56,0.46,1.08,0.68,1.74,0.8c0.66,0.12,1.46,0.13,2.22,0.32c0.75,0.18,1.46,0.53,2.72,0.76 c1.27,0.22,3.1,0.32,3.88,0.92c0.78,0.6,0.5,1.7,0.07,3c-0.42,1.3-0.98,2.79-1.8,4.49c-0.82,1.7-1.89,3.61-3.35,5.63 c-1.46,2.02-3.3,4.15-5.08,5.88c-1.78,1.73-3.5,3.06-5.34,4.23c-1.84,1.17-3.79,2.19-5.81,3.02c-2.02,0.83-4.11,1.49-6.44,1.96 c-2.32,0.47-4.88,0.76-7.34,0.79c-2.46,0.04-4.84-0.17-7.22-0.63c-2.39-0.46-4.78-1.16-7.04-2.07c-2.25-0.9-4.36-2.01-6.04-3.03 c-1.68-1.02-2.94-1.96-3.9-2.73C316.57,117.2,315.92,116.6,316.18,115.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049909524798175500190000012010910712683411358_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.1995,
    y1: 92.5877,
    x2: 397.7621,
    y2: 92.5877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000049909524798175500190000012010910712683411358_)"
    },
    d: " M354.91,52.46c0.46-1.83,1.79-5.11,2.7-6.72c0.91-1.6,1.4-1.53,2.78-0.98c1.38,0.55,3.64,1.58,5.78,2.79 c2.14,1.21,4.15,2.61,6.14,4.32c1.99,1.72,3.96,3.76,5.79,5.91c1.83,2.15,3.52,4.4,4.97,6.69c1.46,2.29,2.68,4.63,3.66,7.41 c0.98,2.78,1.73,6,2.23,9.19c0.5,3.19,0.75,6.34,0.76,9.06c0.01,2.72-0.21,5-0.17,6.11c0.04,1.11,0.35,1.06,1.21,1.38 c0.86,0.32,2.27,1.03,3.15,2.39c0.89,1.36,1.25,3.37,1.53,4.92c0.28,1.55,0.48,2.63,0.29,3.39c-0.18,0.75-0.75,1.17-1.26,1.43 c-0.51,0.25-0.98,0.34-1.26,0.55c-0.28,0.21-0.38,0.55-0.32,1.34c0.06,0.79,0.29,2.03,1.13,6.67c0.84,4.65,2.3,12.7,3.08,16.91 c0.78,4.22,0.88,4.6,0.11,4.98c-0.77,0.38-2.41,0.75-3.28,0.47c-0.87-0.28-0.96-1.23-1.83-6.27c-0.87-5.04-2.53-14.17-3.9-18.64 c-1.37-4.47-2.45-4.27-3.09-4.24c-0.63,0.03-0.82-0.09-1.26,0.55c-0.44,0.64-1.15,2.05-2.48,3.97c-1.33,1.92-3.29,4.35-5.52,6.6 c-2.23,2.24-4.74,4.3-7.6,6.18c-2.86,1.88-6.07,3.58-9.19,4.87c-3.13,1.29-6.17,2.16-9.34,2.73c-3.17,0.58-6.48,0.86-9.69,0.8 c-3.21-0.06-6.32-0.45-8.66-0.99c-2.34-0.54-3.9-1.21-4.85-1.6c-0.95-0.39-1.29-0.49-1.34-0.8c-0.06-0.31,0.17-0.83,0.8-2.43 c0.63-1.6,1.67-4.27,2.31-5.56c0.64-1.29,0.89-1.21,1.16-1.11c0.27,0.09,0.57,0.19,0.59,1.12c0.01,0.93-0.26,2.7-0.31,3.65 c-0.05,0.95,0.14,1.08,1.07,1.39c0.94,0.31,2.63,0.8,5,1.09c2.37,0.29,5.43,0.37,8.72,0.02c3.29-0.36,6.83-1.16,9.78-2.09 c2.95-0.93,5.31-2,7.76-3.49c2.45-1.48,4.98-3.38,7.45-5.67c2.46-2.29,4.86-4.96,6.69-7.21c1.83-2.25,3.1-4.08,4.37-6.79 c1.27-2.71,2.54-6.3,3.08-9.91c0.54-3.62,0.36-7.26,0.01-10.96c-0.35-3.69-0.87-7.44-1.98-10.92c-1.11-3.48-2.81-6.69-4.91-9.42 c-2.1-2.74-4.59-5.01-6.79-7.01c-2.2-2-4.12-3.73-5.7-4.96c-1.58-1.23-2.83-1.97-3.63-2.38c-0.8-0.42-1.13-0.51-1.75,0.08 c-0.61,0.59-1.5,1.87-2.16,2.62c-0.66,0.75-1.1,0.97-1.51,0.88C354.84,54.68,354.45,54.29,354.91,52.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040534700408165469790000014950849924212924837_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.0594,
    y1: 230.1718,
    x2: 372.7454,
    y2: 230.1718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000040534700408165469790000014950849924212924837_)"
    },
    points: " 362.4,267.26 362.06,193.13 372.4,193.08 372.75,267.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048461580536664525690000010728176897648876952_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3842,
    y1: 263.6864,
    x2: 365.8326,
    y2: 263.6864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000048461580536664525690000010728176897648876952_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.38,
    y1: 263.69,
    x2: 365.83,
    y2: 263.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085245600240547325990000007223995803400277686_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3709,
    y1: 260.791,
    x2: 365.8192,
    y2: 260.791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000085245600240547325990000007223995803400277686_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.37,
    y1: 260.8,
    x2: 365.82,
    y2: 260.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045615497466661362510000001140837618574506884_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3579,
    y1: 257.9176,
    x2: 365.8059,
    y2: 257.9176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000045615497466661362510000001140837618574506884_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.36,
    y1: 257.93,
    x2: 365.81,
    y2: 257.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086668410071815937090000004431378948189194656_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3445,
    y1: 255.0441,
    x2: 365.7926,
    y2: 255.0441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000086668410071815937090000004431378948189194656_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.34,
    y1: 255.05,
    x2: 365.79,
    y2: 255.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105425155639502629400000001733611186891872143_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3312,
    y1: 252.1707,
    x2: 365.7796,
    y2: 252.1707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000105425155639502629400000001733611186891872143_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.33,
    y1: 252.18,
    x2: 365.78,
    y2: 252.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066482274727158433130000006016611891398189747_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3182,
    y1: 249.2971,
    x2: 365.7662,
    y2: 249.2971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000066482274727158433130000006016611891398189747_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.32,
    y1: 249.31,
    x2: 365.77,
    y2: 249.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129915553018017810420000018391930111851528098_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.3049,
    y1: 246.4236,
    x2: 365.7529,
    y2: 246.4236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000129915553018017810420000018391930111851528098_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.3,
    y1: 246.43,
    x2: 365.75,
    y2: 246.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145756268868579947500000009565315680156965005_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2915,
    y1: 243.5502,
    x2: 365.7399,
    y2: 243.5502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000145756268868579947500000009565315680156965005_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.29,
    y1: 243.56,
    x2: 365.74,
    y2: 243.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174598476110221380150000009870535258492581775_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2785,
    y1: 240.6769,
    x2: 365.7266,
    y2: 240.6769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000174598476110221380150000009870535258492581775_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.28,
    y1: 240.68,
    x2: 365.73,
    y2: 240.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163790671962576404630000009507160891310785461_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2652,
    y1: 237.8033,
    x2: 365.7132,
    y2: 237.8033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000163790671962576404630000009507160891310785461_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.27,
    y1: 237.81,
    x2: 365.71,
    y2: 237.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020365704889778997550000005546942508124512388_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2518,
    y1: 234.9297,
    x2: 365.7002,
    y2: 234.9297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000020365704889778997550000005546942508124512388_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.25,
    y1: 234.94,
    x2: 365.7,
    y2: 234.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120557230478653351290000009608191440095917215_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2388,
    y1: 232.056,
    x2: 365.6869,
    y2: 232.056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000120557230478653351290000009608191440095917215_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.24,
    y1: 232.06,
    x2: 365.69,
    y2: 232.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057832435581382230790000012290426842802983575_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2255,
    y1: 229.1828,
    x2: 365.6735,
    y2: 229.1828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000057832435581382230790000012290426842802983575_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.23,
    y1: 229.19,
    x2: 365.67,
    y2: 229.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078754407433620276060000004382537483548565149_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.2122,
    y1: 226.3091,
    x2: 365.6605,
    y2: 226.3091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000078754407433620276060000004382537483548565149_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.21,
    y1: 226.32,
    x2: 365.66,
    y2: 226.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042736423903030982200000009469453008685091982_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1991,
    y1: 223.4359,
    x2: 365.6472,
    y2: 223.4359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000042736423903030982200000009469453008685091982_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.2,
    y1: 223.44,
    x2: 365.65,
    y2: 223.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026884841660925413270000008326462414919777161_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1858,
    y1: 220.5623,
    x2: 365.6339,
    y2: 220.5623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000026884841660925413270000008326462414919777161_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.19,
    y1: 220.57,
    x2: 365.63,
    y2: 220.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027599886253553678930000001647439813123552173_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1725,
    y1: 217.6886,
    x2: 365.6208,
    y2: 217.6886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000027599886253553678930000001647439813123552173_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.17,
    y1: 217.7,
    x2: 365.62,
    y2: 217.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026878594496954695120000003402992793864768171_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1594,
    y1: 214.8152,
    x2: 365.6075,
    y2: 214.8152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000026878594496954695120000003402992793864768171_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.16,
    y1: 214.82,
    x2: 365.61,
    y2: 214.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054261735851147338460000011641129894249957790_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1461,
    y1: 211.9417,
    x2: 365.5945,
    y2: 211.9417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000054261735851147338460000011641129894249957790_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.15,
    y1: 211.95,
    x2: 365.59,
    y2: 211.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050642571012133987560000010402642668970310553_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1328,
    y1: 209.0681,
    x2: 365.5811,
    y2: 209.0681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000050642571012133987560000010402642668970310553_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.13,
    y1: 209.08,
    x2: 365.58,
    y2: 209.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063635221839950681050000008655014117308191410_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1197,
    y1: 206.1949,
    x2: 365.5678,
    y2: 206.1949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000063635221839950681050000008655014117308191410_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.12,
    y1: 206.2,
    x2: 365.57,
    y2: 206.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103946962714418900800000003925826552616168320_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1064,
    y1: 203.3212,
    x2: 365.5548,
    y2: 203.3212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000103946962714418900800000003925826552616168320_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.11,
    y1: 203.33,
    x2: 365.55,
    y2: 203.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053534878501003667540000002955511500625947035_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.0931,
    y1: 200.4478,
    x2: 365.5414,
    y2: 200.4478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000053534878501003667540000002955511500625947035_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.09,
    y1: 200.46,
    x2: 365.54,
    y2: 200.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113353867583302954030000016756691367127197877_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.0801,
    y1: 197.5739,
    x2: 365.5281,
    y2: 197.5739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000113353867583302954030000016756691367127197877_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    x1: 362.08,
    y1: 197.58,
    x2: 365.53,
    y2: 197.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114770893458247553280000000245666601771421066_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.9336,
    y1: 184.8553,
    x2: 422.1804,
    y2: 184.8553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052083224048005297080000004017813618004396683_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.6502,
    y1: 184.8553,
    x2: 422.4638,
    y2: 184.8553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#455AA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000114770893458247553280000000245666601771421066_)",
      stroke: "url(#SVGID_00000052083224048005297080000004017813618004396683_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M410.3,207.47c1.88-2.2,5.3-6.58,7.67-10.99c2.37-4.4,3.68-8.82,4.08-12.83c0.4-4.01-0.12-7.62-1.25-10.62 c-1.13-3-2.88-5.4-5.46-7.52c-2.58-2.12-6-3.97-9.78-5c-3.78-1.04-7.91-1.26-12.23-0.47c-4.32,0.79-8.82,2.59-12.37,5.17 c-3.55,2.58-6.16,5.93-7.32,9.92c-1.16,3.99-0.87,8.61,0.65,13.33c1.52,4.72,4.25,9.53,6.58,12.96c2.32,3.43,4.23,5.49,5.57,6.8 c1.34,1.31,2.11,1.88,2.79,1.91c0.67,0.02,1.25-0.5,2.45-1.46c1.2-0.96,3.01-2.35,4.5-3.28c1.49-0.92,2.66-1.38,4.1-1.12 c1.44,0.26,3.15,1.22,4.44,2.24c1.29,1.02,2.16,2.09,2.77,2.62C408.08,209.68,408.42,209.67,410.3,207.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114777662060048767900000008679278177497746595_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.4952,
    y1: 215.5633,
    x2: 414.5031,
    y2: 215.5633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085222173556529996100000003871453646746853264_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.2953,
    y1: 215.5633,
    x2: 415.703,
    y2: 215.5633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000114777662060048767900000008679278177497746595_)",
      stroke: "url(#SVGID_00000085222173556529996100000003871453646746853264_)",
      strokeWidth: 2.3998,
      strokeMiterlimit: 22.9256
    },
    d: " M414.13,224.51c0.6-1.33,0.54-3.57-0.77-6.26c-1.31-2.69-3.87-5.83-5.68-7.88c-1.81-2.05-2.87-3.02-4.11-3.8 c-1.24-0.78-2.66-1.37-3.92-1.48c-1.26-0.11-2.35,0.27-3.61,0.97c-1.26,0.71-2.68,1.74-3.92,2.66c-1.24,0.92-2.3,1.72-3.69,3.98 c-1.4,2.26-3.14,5.98-3.71,8.27c-0.58,2.29,0,3.15,0.85,3.33c0.84,0.18,1.95-0.33,4.17-0.95c2.22-0.62,5.56-1.35,8.27-1.34 c2.72,0.01,4.81,0.75,6.87,1.65c2.06,0.9,4.09,1.97,5.73,2.28C412.26,226.27,413.53,225.84,414.13,224.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117644768255939592710000004079049565110276532_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.2339,
    y1: 179.9375,
    x2: 403.261,
    y2: 179.9375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000117644768255939592710000004079049565110276532_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M391.36,189.03l-0.04-3.48c1.37,1.02,2.85,1.62,4.44,1.82l-0.05-4.61c-1.74-0.52-3.08-1.29-4.03-2.33 c-0.95-1.04-1.43-2.16-1.44-3.36c-0.02-1.39,0.44-2.57,1.36-3.54c0.93-0.97,2.25-1.62,3.98-1.95l-0.04-3.11l2.38-0.03l0.04,3.11 c1.71,0.25,3.36,0.88,4.97,1.89l0.04,3.34c-1.74-1.3-3.4-2.07-4.98-2.32l0.06,5.48c3.44,0.76,5.18,2.55,5.21,5.35 c0.02,1.29-0.43,2.41-1.35,3.36c-0.91,0.95-2.16,1.53-3.74,1.73l0.01,1.02l-2.38,0.03l-0.01-1.02 C394.43,190.38,392.95,189.92,391.36,189.03L391.36,189.03z M398.09,183.58l0.04,3.75c1.26-0.33,1.88-0.94,1.87-1.84 C400,184.61,399.36,183.98,398.09,183.58L398.09,183.58z M395.66,179.2l-0.05-4.65c-1.45,0.35-2.17,1.11-2.15,2.26 C393.47,177.91,394.21,178.71,395.66,179.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129904795505097474170000006383239220325866906_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.378,
    y1: 542.3649,
    x2: 450.2218,
    y2: 542.3649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000129904795505097474170000006383239220325866906_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M448.95,589.28c-1.76,1.69-5.62,4.46-7.68,5.83c-2.06,1.37-2.32,1.32-7.48-6.61c-5.16-7.93-15.21-23.75-20.27-31.75 c-5.06-8-5.12-8.19-4.9-8.96c0.22-0.77,0.71-2.13,0.98-2.98c0.27-0.85,0.33-1.2-0.41-2.4c-0.75-1.2-2.29-3.25-3.19-4.33 c-0.9-1.09-1.15-1.22-1.88-1.38c-0.74-0.17-1.96-0.37-2.7-0.49c-0.74-0.12-1-0.16-2.49-2.29c-1.49-2.13-4.21-6.34-5.69-9.59 c-1.49-3.25-1.74-5.53-1.82-8.06c-0.08-2.52,0.01-5.29,0.76-8.17c0.74-2.88,2.13-5.88,3.77-8.22c1.64-2.33,3.52-4,6.05-5.74 c2.53-1.74,5.69-3.55,8.71-4.45c3.02-0.9,5.88-0.88,8.96-0.51c3.08,0.37,6.37,1.09,9.2,2.45c2.83,1.36,5.19,3.36,7.18,6.02 c1.99,2.66,3.6,5.97,4.46,9.16c0.87,3.19,0.99,6.26,0.7,9.94c-0.29,3.67-0.99,7.95-1.68,12.73c-0.69,4.77-1.38,10.04-1.66,14.53 c-0.29,4.48-0.17,8.18,0.34,12.43c0.51,4.25,1.43,9.07,2.9,13.48c1.47,4.41,3.51,8.42,5.09,11.1c1.58,2.68,2.7,4.03,3.44,5 C450.35,587,450.7,587.59,448.95,589.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182505491028751298150000005382765352828471204_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.9044,
    y1: 514.6013,
    x2: 433.8324,
    y2: 514.6013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000182505491028751298150000005382765352828471204_)",
      stroke: "#FFFFFF",
      strokeWidth: 4.7999,
      strokeMiterlimit: 22.9256
    },
    d: " M433.61,517.26c-1.47,8.97-9.93,15.05-18.91,13.58c-8.97-1.47-15.05-9.93-13.58-18.91c1.47-8.97,9.93-15.05,18.91-13.58 C429,499.83,435.08,508.29,433.61,517.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096035997857324603230000006929838876576546238_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.8985,
    y1: 487.632,
    x2: 408.776,
    y2: 487.632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047742014722623859460000012105311438083610533_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.4586,
    y1: 487.632,
    x2: 410.2159,
    y2: 487.632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000096035997857324603230000006929838876576546238_)",
      stroke: "url(#SVGID_00000047742014722623859460000012105311438083610533_)",
      strokeWidth: 2.8797,
      strokeMiterlimit: 22.9256
    },
    d: " M408.67,488.83c-0.67,4.12-4.51,6.93-8.56,6.26c-4.05-0.66-6.79-4.54-6.11-8.66c0.67-4.12,4.51-6.93,8.56-6.26 C406.61,480.83,409.35,484.71,408.67,488.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093890570853581499240000001533704484686048657_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.1736,
    y1: 274.1998,
    x2: 417.7067,
    y2: 274.1998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ECC3B",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055666489544361371360000010583756968223051920_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.5736,
    y1: 274.1998,
    x2: 418.3067,
    y2: 274.1998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000093890570853581499240000001533704484686048657_)",
      stroke: "url(#SVGID_00000055666489544361371360000010583756968223051920_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    cx: 402.44,
    cy: 274.2,
    r: 15.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136382196304050498190000014436899149332307628_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.1683,
    y1: 265.1398,
    x2: 411.4036,
    y2: 265.3528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036245797714723444430000005865981666153378450_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.7899,
    y1: 266.8688,
    x2: 414.3658,
    y2: 266.8688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000136382196304050498190000014436899149332307628_)",
      stroke: "url(#SVGID_00000036245797714723444430000005865981666153378450_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M412.77,265.91c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C413.86,266.03,413.3,265.74,412.77,265.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035524386202384956200000009532307680956508306_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.8135,
    y1: 267.009,
    x2: 411.0488,
    y2: 267.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081643803591059539440000007778734690647118744_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.2153,
    y1: 270.3498,
    x2: 415.7911,
    y2: 270.3498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000035524386202384956200000009532307680956508306_)",
      stroke: "url(#SVGID_00000081643803591059539440000007778734690647118744_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M414.2,269.39c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C415.29,269.51,414.72,269.22,414.2,269.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129926975129473954290000009957416021027684263_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.8279,
    y1: 269.3966,
    x2: 410.0631,
    y2: 269.6096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123429613787986492180000001949174578717779608_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.7957,
    y1: 274.1554,
    x2: 416.3716,
    y2: 274.1554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000129926975129473954290000009957416021027684263_)",
      stroke: "url(#SVGID_00000123429613787986492180000001949174578717779608_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M414.78,273.2c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C415.87,273.32,415.3,273.03,414.78,273.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072267499210971431580000003756728300943324076_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.6546,
    y1: 269.1645,
    x2: 408.8899,
    y2: 269.3775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142175515867482349920000002455882305094769536_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.7819,
    y1: 272.2567,
    x2: 413.3577,
    y2: 272.2567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000072267499210971431580000003756728300943324076_)",
      stroke: "url(#SVGID_00000142175515867482349920000002455882305094769536_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M411.76,271.3c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C412.86,271.42,412.29,271.13,411.76,271.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047762790064809993990000000978529580208915853_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.3295,
    y1: 267.1514,
    x2: 409.5648,
    y2: 267.3644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124875573836022024190000002769470364382203324_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.9287,
    y1: 268.8602,
    x2: 412.5046,
    y2: 268.8602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000047762790064809993990000000978529580208915853_)",
      stroke: "url(#SVGID_00000124875573836022024190000002769470364382203324_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M410.91,267.9c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C412,268.02,411.44,267.73,410.91,267.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048471043083730744910000011699383051621470094_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.3437,
    y1: 271.8441,
    x2: 408.5789,
    y2: 272.0572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008833869430730476210000013693738830569632391_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.285,
    y1: 277.4844,
    x2: 415.8608,
    y2: 277.4844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000048471043083730744910000011699383051621470094_)",
      stroke: "url(#SVGID_00000008833869430730476210000013693738830569632391_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M414.27,276.53c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C415.36,276.65,414.79,276.36,414.27,276.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140005271498003889230000017226008123070046643_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.5552,
    y1: 271.2532,
    x2: 407.7905,
    y2: 271.4662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047756645443021408750000006434428493691412137_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.7353,
    y1: 275.2988,
    x2: 413.3111,
    y2: 275.2988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000140005271498003889230000017226008123070046643_)",
      stroke: "url(#SVGID_00000047756645443021408750000006434428493691412137_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M411.72,274.34c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C412.81,274.46,412.24,274.17,411.72,274.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115504915294198506650000008005712555963088523_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.2985,
    y1: 274.5966,
    x2: 406.5338,
    y2: 274.8096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153666183030433653960000010264237822369119118_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.8373,
    y1: 280.7779,
    x2: 414.4131,
    y2: 280.7779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000115504915294198506650000008005712555963088523_)",
      stroke: "url(#SVGID_00000153666183030433653960000010264237822369119118_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M412.82,279.82c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C413.91,279.94,413.35,279.65,412.82,279.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021115145576061458290000009425361394542856354_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.8046,
    y1: 273.6248,
    x2: 406.0399,
    y2: 273.8378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028294999108296953440000010453597759487527083_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.5144,
    y1: 278.1499,
    x2: 412.0902,
    y2: 278.1499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000021115145576061458290000009425361394542856354_)",
      stroke: "url(#SVGID_00000028294999108296953440000010453597759487527083_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M410.49,277.19c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C411.59,277.31,411.02,277.02,410.49,277.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064342113835987040530000011684591424031016611_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.2318,
    y1: 276.9946,
    x2: 404.4671,
    y2: 277.2076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143579218994612711490000016588494781086082199_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.9059,
    y1: 283.2984,
    x2: 412.4818,
    y2: 283.2984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000064342113835987040530000011684591424031016611_)",
      stroke: "url(#SVGID_00000143579218994612711490000016588494781086082199_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M410.89,282.34c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C411.98,282.46,411.41,282.17,410.89,282.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097469149413920957600000014055436605646654109_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.993,
    y1: 285.6283,
    x2: 409.5688,
    y2: 285.6283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#000002",
      stroke: "url(#SVGID_00000097469149413920957600000014055436605646654109_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M407.97,284.67c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C409.07,284.79,408.5,284.5,407.97,284.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132791362115414027230000016313418242805187202_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.6307,
    y1: 286.816,
    x2: 406.2065,
    y2: 286.816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#000002",
      stroke: "url(#SVGID_00000132791362115414027230000016313418242805187202_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M404.61,285.86c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C405.7,285.98,405.14,285.69,404.61,285.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011738551633642846200000017444301918583677625_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.7632,
    y1: 276.18,
    x2: 403.9985,
    y2: 276.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000002"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132797595422422099900000000161790323476864160_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.8343,
    y1: 281.0324,
    x2: 410.4103,
    y2: 281.0324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000011738551633642846200000017444301918583677625_)",
      stroke: "url(#SVGID_00000132797595422422099900000000161790323476864160_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M408.81,280.08c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C409.91,280.2,409.34,279.91,408.81,280.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141417682800499305030000010408164505427912592_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.0472,
    y1: 283.3544,
    x2: 407.623,
    y2: 283.3544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#000002",
      stroke: "url(#SVGID_00000141417682800499305030000010408164505427912592_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M406.03,282.4c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C407.12,282.52,406.56,282.23,406.03,282.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021821521543478188450000012445756964139795076_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.1466,
    y1: 264.5552,
    x2: 411.7225,
    y2: 264.5552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      stroke: "url(#SVGID_00000021821521543478188450000012445756964139795076_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M410.13,263.6c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C411.22,263.72,410.65,263.43,410.13,263.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073683009944806459730000000774372846396745895_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.5031,
    y1: 286.7678,
    x2: 403.0788,
    y2: 286.7678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      stroke: "url(#SVGID_00000073683009944806459730000000774372846396745895_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M401.48,285.81c-0.53,0.17-0.82,0.74-0.65,1.26c0.17,0.53,0.74,0.82,1.26,0.65c0.53-0.17,0.82-0.74,0.65-1.26 C402.58,285.93,402.01,285.64,401.48,285.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047780811852509917010000006056208373456699571_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.274,
    y1: 316.4583,
    x2: 404.4548,
    y2: 316.4583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000047780811852509917010000006056208373456699571_)"
    },
    d: " M402.96,307.39c-1.88,2.17-5.94,5.97-10.6,9.77c-4.66,3.81-9.91,7.62-14.59,10.8c-4.68,3.17-8.8,5.71-12.27,7.98 c-3.46,2.27-6.28,4.26-8.77,6.15c-2.49,1.89-4.67,3.68-6.36,5.13c-1.69,1.46-2.89,2.59-3.88,3.36c-0.99,0.77-1.75,1.19-2.42,1.33 c-0.67,0.14-1.24,0-1.98-0.29c-0.74-0.29-1.64-0.73-2.08-0.98c-0.44-0.25-0.42-0.3-0.18-0.65c0.25-0.35,0.72-0.99,1.21-1.22 c0.49-0.23,0.98-0.06,1.57,0.05c0.58,0.11,1.25,0.16,2.1-0.23c0.85-0.39,1.88-1.2,3.09-2.27c1.21-1.07,2.6-2.38,3.74-3.75 c1.13-1.37,2.01-2.81,2.59-4.12c0.59-1.32,0.88-2.52,0.77-3.43c-0.12-0.91-0.64-1.53-1.44-2c-0.8-0.47-1.87-0.78-2.83-0.87 c-0.96-0.09-1.82,0.05-2.99,0.82c-1.17,0.77-2.66,2.18-3.79,3.36c-1.13,1.19-1.9,2.16-2.66,3.17c-0.76,1.01-1.5,2.05-1.93,2.93 c-0.43,0.87-0.55,1.58-0.42,2.27c0.13,0.7,0.51,1.39,0.79,1.83c0.28,0.44,0.46,0.63,0.23,1.01c-0.23,0.39-0.87,0.97-1.47,0.91 c-0.6-0.06-1.17-0.75-1.58-1.52c-0.42-0.77-0.68-1.6-0.44-2.73c0.24-1.13,0.98-2.54,2.27-4.52c1.28-1.97,3.1-4.51,4.98-7.3 c1.88-2.79,3.81-5.84,5.65-9.14c1.84-3.3,3.58-6.85,5.52-10.37c1.94-3.51,4.09-6.99,6.58-10.62s5.3-7.43,7.71-10.66 c2.4-3.23,4.39-5.89,5.79-7.57c1.4-1.68,2.21-2.4,2.83-2.77c0.63-0.37,1.07-0.4,1.63-0.21c0.55,0.19,1.21,0.61,1.33,1.09 c0.11,0.47-0.32,1.01-1.46,2.31c-1.14,1.31-2.99,3.4-5.15,6.12c-2.16,2.72-4.64,6.08-6.79,9.11c-2.15,3.04-3.97,5.75-5.18,7.97 c-1.21,2.22-1.81,3.93-2.32,5.37c-0.5,1.44-0.91,2.6-1.01,3.5c-0.1,0.9,0.12,1.53,0.5,2.04c0.38,0.51,0.93,0.89,1.63,1.1 c0.7,0.21,1.55,0.26,2.61-0.27c1.06-0.53,2.31-1.64,4.47-3.81c2.16-2.17,5.21-5.38,9.38-9.95c4.18-4.56,9.48-10.47,12.27-13.41 c2.8-2.93,3.09-2.89,3.6-2.65c0.51,0.24,1.22,0.68,1.6,1.03c0.38,0.35,0.41,0.61-1.16,2.33c-1.56,1.72-4.73,4.9-8.06,8.39 c-3.33,3.49-6.84,7.3-9.58,10.16c-2.74,2.86-4.72,4.78-6.13,6.43c-1.42,1.65-2.27,3.03-2.71,4.27c-0.44,1.24-0.45,2.36-0.15,3.18 c0.3,0.82,0.93,1.35,1.63,1.66c0.7,0.31,1.48,0.39,2.52,0.17c1.04-0.23,2.35-0.76,4.61-2.17c2.26-1.41,5.49-3.7,8.41-5.91 c2.92-2.21,5.53-4.34,7.96-6.41c2.43-2.07,4.69-4.07,6.4-5.59c1.71-1.51,2.88-2.53,3.59-3.15c0.71-0.62,0.98-0.84,1.25-0.74 c0.28,0.1,0.57,0.51,0.87,0.99C404.53,304.68,404.84,305.22,402.96,307.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075885373654123664900000017315450597693168569_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.3385,
    y1: 300.7843,
    x2: 390.5869,
    y2: 300.7843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000075885373654123664900000017315450597693168569_)"
    },
    d: " M388.86,290.78c-2.19,2.62-6.62,7.65-10.73,12.11c-4.11,4.46-7.89,8.36-10.29,10.75c-2.39,2.39-3.39,3.29-4.23,3.74 c-0.84,0.45-1.53,0.46-2.09,0.29c-0.56-0.17-1-0.51-1.14-1.08c-0.14-0.58,0.02-1.39,0.71-3.01c0.69-1.62,1.92-4.05,3.48-6.67 c1.57-2.62,3.48-5.43,6.11-8.95c2.63-3.52,5.98-7.75,7.97-10.26c1.99-2.5,2.64-3.27,3.05-3.65c0.41-0.38,0.6-0.38,2.1,0.3 c1.5,0.68,4.32,2.04,5.75,2.82C391,287.96,391.06,288.16,388.86,290.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112590700916284522500000008703603500090567605_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.3744,
    y1: 309.0907,
    x2: 401.7079,
    y2: 309.0907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000112590700916284522500000008703603500090567605_)"
    },
    d: " M400.05,303.55c-1.98,1.85-5.95,5.37-9.52,8.38c-3.57,3.01-6.74,5.5-9.46,7.5c-2.72,2-4.99,3.5-6.66,4.47 c-1.67,0.97-2.76,1.4-3.55,1.46c-0.8,0.06-1.31-0.24-1.75-0.58c-0.44-0.34-0.8-0.72-0.72-1.4c0.08-0.68,0.62-1.68,2.35-3.78 c1.73-2.1,4.65-5.3,7.92-8.78c3.27-3.48,6.89-7.25,9.49-9.97c2.6-2.72,4.18-4.41,5.27-5.55c1.08-1.14,1.67-1.75,2.09-2.16 c0.42-0.41,0.69-0.63,1.75,0.77c1.06,1.4,2.93,4.41,3.86,6.01C402.04,301.51,402.03,301.69,400.05,303.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044898246082416512880000011944833946098413186_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.6461,
    y1: 415.9434,
    x2: 386.7323,
    y2: 415.9434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    style: {
      stopColor: "#4C7972"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3453,
    style: {
      stopColor: "#7F6B5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3865,
    style: {
      stopColor: "#9F5B4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    style: {
      stopColor: "#B74941"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4649,
    style: {
      stopColor: "#C73739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#D02634"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    style: {
      stopColor: "#D41F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8123,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000044898246082416512880000011944833946098413186_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M334.31,452.81c-1.33-0.6-3.76-2.07-4.97-2.81c-1.21-0.74-1.21-0.74,3.09-6.81c4.3-6.07,12.9-18.22,17.57-25.02 c4.67-6.8,5.42-8.25,6.42-10.62c0.99-2.37,2.23-5.67,3.12-8.87c0.9-3.2,1.45-6.32,1.87-9.47c0.42-3.15,0.69-6.34,0.94-8.2 c0.25-1.86,0.47-2.39,0.61-2.06c0.14,0.33,0.2,1.5,0.33,2.84c0.13,1.34,0.33,2.84,0.24,4.79c-0.1,1.95-0.49,4.34-1.01,6.9 c-0.53,2.56-1.19,5.28-2.07,7.88c-0.88,2.6-1.97,5.08-2.55,6.38c-0.58,1.3-0.65,1.42-0.09,1.87c0.56,0.45,1.76,1.21,2.37,1.56 c0.62,0.35,0.65,0.29,1.46-0.47c0.81-0.76,2.38-2.23,4.49-3.92c2.11-1.69,4.76-3.6,7.32-5.28c2.56-1.68,5.02-3.13,7.17-4.02 c2.15-0.89,3.98-1.23,5.07-1.22c1.09,0.01,1.45,0.38,0.5,0.98c-0.95,0.6-3.22,1.42-5.79,2.77c-2.57,1.35-5.44,3.21-8.05,4.99 c-2.61,1.77-4.96,3.45-6.66,4.84c-1.7,1.4-2.75,2.51-3.67,3.62c-0.92,1.11-1.71,2.2-6.01,8.77c-4.3,6.57-12.09,18.6-16.11,24.75 C335.88,453.14,335.64,453.41,334.31,452.81z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M370.14,391.58c-1.81-1.34-4.21-3.17-5.68-5.44c-1.47-2.27-2.02-5-2.29-8.23c-0.26-3.23-0.24-6.98,0.11-10.37 c0.35-3.39,1.03-6.43,2.48-9.89c1.45-3.46,3.67-7.33,5.98-10.58c2.31-3.25,4.72-5.88,7.61-8.14c2.89-2.26,6.27-4.17,9.27-5.47 c3-1.31,5.61-2.01,7.89-2.3c2.29-0.28,4.25-0.14,6.18,0.19c1.93,0.33,3.84,0.85,5.97,1.91c2.13,1.06,4.48,2.65,6.17,4.48 c1.69,1.83,2.72,3.89,3.53,6.03c0.81,2.14,1.42,4.37,1.71,7.07c0.29,2.7,0.27,5.87-0.22,9.35c-0.48,3.48-1.43,7.27-2.89,10.89 c-1.46,3.62-3.43,7.06-5.69,9.93c-2.26,2.87-4.8,5.17-7.75,7.32c-2.95,2.15-6.3,4.15-8.83,5.5c-2.53,1.35-4.24,2.04-6.62,2.43 c-2.39,0.39-5.46,0.47-7.68,0.15c-2.23-0.32-3.62-1.03-4.92-1.82C373.17,393.79,371.95,392.93,370.14,391.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026165418732602371820000008688962287609881762_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.2823,
    y1: 391.0487,
    x2: 353.1925,
    y2: 391.0487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000026165418732602371820000008688962287609881762_)"
    },
    d: " M353,394.26c-0.31,0.28-1.03,0.8-1.85,1.14c-0.81,0.34-1.72,0.49-2.57,0.59c-0.85,0.1-1.66,0.14-2.6,0.03 c-0.94-0.11-2.03-0.38-3.04-0.78c-1.01-0.4-1.95-0.95-2.92-1.69c-0.96-0.74-1.95-1.68-2.63-2.55c-0.67-0.86-1.04-1.65-1.1-2.3 c-0.07-0.65,0.16-1.18,0.48-1.55c0.32-0.37,0.72-0.59,1.39-0.78c0.66-0.2,1.58-0.37,2.4-0.35c0.82,0.03,1.54,0.26,2.39,0.75 c0.85,0.49,1.83,1.24,2.95,2.22c1.13,0.98,2.4,2.19,3.46,3.02c1.06,0.84,1.91,1.3,2.49,1.55c0.58,0.25,0.91,0.29,1.13,0.33 C353.2,393.93,353.31,393.98,353,394.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074409762885861239720000002889013459954704831_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.74,
    y1: 383.6897,
    x2: 358.7237,
    y2: 383.6897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034057642273136184590000016141045000694107826_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.24,
    y1: 383.6897,
    x2: 359.2237,
    y2: 383.6897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000074409762885861239720000002889013459954704831_)",
      stroke: "url(#SVGID_00000034057642273136184590000016141045000694107826_)",
      strokeMiterlimit: 10
    },
    d: " M358.25,380.95c0.25,0.66,0.46,1.61,0.48,2.75c0.02,1.14-0.15,2.46-0.53,3.76c-0.38,1.29-0.95,2.56-1.55,3.45 c-0.6,0.89-1.22,1.4-1.71,1.7c-0.49,0.29-0.87,0.37-1.37,0.3c-0.5-0.07-1.13-0.28-1.94-0.76c-0.82-0.48-1.82-1.23-2.91-2.17 c-1.09-0.94-2.28-2.06-3.37-2.94c-1.09-0.88-2.09-1.53-3.13-1.85c-1.04-0.32-2.11-0.32-2.95-0.24c-0.84,0.08-1.45,0.25-1.87,0.46 c-0.42,0.21-0.65,0.46-0.82,0.66c-0.18,0.2-0.3,0.34-0.45,0.36c-0.15,0.02-0.31-0.08-0.36-0.5c-0.05-0.43,0.02-1.18,0.16-2.28 c0.14-1.09,0.37-2.53,0.76-3.65c0.4-1.12,0.97-1.93,1.72-2.78c0.75-0.86,1.67-1.76,2.34-2.25c0.67-0.49,1.1-0.57,1.48-0.48 c0.38,0.09,0.71,0.34,1.2,0.62c0.48,0.28,1.12,0.6,2.04,0.79c0.92,0.19,2.13,0.27,3.32,0.39c1.19,0.13,2.35,0.31,3.47,0.63 c1.12,0.32,2.19,0.77,3.04,1.24c0.86,0.47,1.5,0.94,1.96,1.36C357.71,379.94,358,380.3,358.25,380.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122680418160461862250000003932195706509498805_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.028,
    y1: 375.5388,
    x2: 357.3483,
    y2: 375.5388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000122680418160461862250000003932195706509498805_)"
    },
    d: " M356.92,378.1c-0.44-0.26-1.29-0.85-2.27-1.36c-0.98-0.51-2.1-0.94-3.19-1.23c-1.09-0.29-2.16-0.45-3.01-0.53 c-0.85-0.08-1.49-0.07-2.12-0.18c-0.63-0.1-1.24-0.31-1.78-0.51c-0.53-0.2-0.98-0.38-1.25-0.54c-0.27-0.16-0.36-0.29-0.19-0.42 c0.17-0.13,0.59-0.26,1.24-0.36c0.65-0.1,1.53-0.17,2.42-0.14c0.89,0.03,1.78,0.18,2.74,0.41c0.96,0.23,2,0.55,2.93,0.96 c0.93,0.41,1.76,0.9,2.47,1.39c0.71,0.49,1.3,0.97,1.69,1.4s0.61,0.83,0.69,1.06C357.4,378.28,357.36,378.35,356.92,378.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088096225336725545300000013575049493869455539_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.3036,
    y1: 406.1681,
    x2: 354.7075,
    y2: 406.1681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    style: {
      stopColor: "#E6E756"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#D41F32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000088096225336725545300000013575049493869455539_)"
    },
    d: " M354.53,402.78c0.19,0.23,0.25,0.7,0.05,1.62c-0.21,0.92-0.69,2.28-1.6,3.87c-0.91,1.58-2.23,3.38-3.39,4.76 c-1.15,1.38-2.14,2.34-2.96,3.01c-0.83,0.67-1.5,1.05-2.1,1.15c-0.6,0.1-1.13-0.09-3.55-0.62c-2.43-0.54-6.75-1.42-9.11-1.94 c-2.36-0.52-2.76-0.67-3.27-0.92c-0.51-0.25-1.13-0.61-1.66-1.14c-0.53-0.53-0.95-1.24-1.37-2.62c-0.42-1.38-0.84-3.43-1.05-5.43 c-0.22-2-0.24-3.94-0.19-5.41c0.05-1.47,0.17-2.47,0.41-3.07c0.25-0.6,0.63-0.79,0.95-0.87c0.32-0.08,0.58-0.05,0.85,0.21 c0.27,0.27,0.56,0.77,0.94,0.94c0.38,0.17,0.84,0.02,1.31-0.09c0.47-0.11,0.94-0.18,1.42,0.29c0.48,0.47,0.97,1.48,1.3,1.96 c0.33,0.48,0.5,0.43,1.02,0.18c0.53-0.24,1.41-0.68,2.04-0.91c0.63-0.23,1.02-0.25,1.42-0.08c0.4,0.17,0.81,0.54,1.25,1.08 c0.44,0.54,0.91,1.24,1.21,1.6c0.3,0.35,0.43,0.34,0.86-0.07c0.43-0.41,1.16-1.23,1.64-1.62c0.47-0.39,0.69-0.36,0.98,0.12 c0.29,0.48,0.64,1.41,0.97,1.89c0.33,0.48,0.63,0.51,1.16,0.22c0.52-0.29,1.27-0.89,1.77-1.2c0.5-0.31,0.76-0.32,0.99,0.03 c0.24,0.35,0.45,1.08,0.7,1.43c0.26,0.35,0.56,0.34,1.15,0.15c0.59-0.18,1.48-0.54,2.02-0.48c0.54,0.06,0.74,0.52,0.92,0.96 c0.18,0.44,0.33,0.87,0.56,1.11c0.23,0.25,0.54,0.32,0.81,0.24c0.28-0.08,0.52-0.31,0.8-0.43 C354.05,402.56,354.35,402.55,354.53,402.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033342464273667596200000001885323927436593064_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.2888,
    y1: 417.5453,
    x2: 343.2418,
    y2: 417.5453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049216610571824664000000008381411389308997284_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.0053,
    y1: 417.5453,
    x2: 343.5252,
    y2: 417.5453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000033342464273667596200000001885323927436593064_)",
      stroke: "url(#SVGID_00000049216610571824664000000008381411389308997284_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M340.87,418.55c-2.61-0.78-7.99-2.09-10.73-2.71c-2.73-0.63-2.82-0.58-2.85-0.43c-0.03,0.15-0.02,0.41,2.55,1.16 c2.57,0.74,7.69,1.97,10.33,2.6c2.65,0.63,2.82,0.67,2.99,0.55C343.33,419.6,343.49,419.34,340.87,418.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093143941495998576020000017248220404530036158_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.57,
    y1: 422.5203,
    x2: 339.7271,
    y2: 422.5203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000093143941495998576020000017248220404530036158_)",
      stroke: "#2B3087",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M337.89,423.25c-2-0.69-6.12-1.8-8.2-2.29c-2.08-0.49-2.11-0.36-2.12-0.14c-0.01,0.22,0.01,0.52,1.98,1.14 c1.98,0.62,5.92,1.57,7.93,2.05c2.01,0.47,2.1,0.47,2.2,0.33C339.78,424.2,339.9,423.94,337.89,423.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111166902529796804580000009006221017377647781_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.0839,
    y1: 429.9247,
    x2: 338.8369,
    y2: 429.9247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADD4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000111166902529796804580000009006221017377647781_)"
    },
    d: " M336.88,426.85c-1.87-0.57-5.5-1.53-7.36-1.95c-1.86-0.42-1.94-0.28-2.04,0.28c-0.1,0.57-0.22,1.57-0.31,2.61 c-0.09,1.04-0.16,2.12,0.03,3.24c0.19,1.11,0.64,2.25,1.27,3c0.62,0.74,1.42,1.09,2.48,1.16c1.06,0.07,2.39-0.13,3.46-0.64 c1.07-0.51,1.89-1.33,2.55-2.36c0.66-1.03,1.15-2.27,1.45-3.04c0.3-0.77,0.42-1.08,0.42-1.32 C338.85,427.58,338.75,427.41,336.88,426.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139988969072715646520000010851876500256943535_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.6674,
    y1: 421.6451,
    x2: 342.1833,
    y2: 421.6451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000139988969072715646520000010851876500256943535_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M341.67,419.53c-0.83,1.41-1.65,2.83-2.48,4.24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016755469730820513820000002114370739237761668_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.7117,
    y1: 420.9357,
    x2: 339.2883,
    y2: 420.9357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000016755469730820513820000002114370739237761668_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M338.72,418.83c-0.48,1.41-0.96,2.81-1.2,3.52c-0.24,0.7-0.24,0.7-0.24,0.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109711126801080998590000012551775473787360407_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.4186,
    y1: 420.2943,
    x2: 336.8385,
    y2: 420.2943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000109711126801080998590000012551775473787360407_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M336.27,418.23c-0.42,1.38-0.85,2.75-1.27,4.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078757200373798029430000016010680524698398606_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.7565,
    y1: 419.6701,
    x2: 333.7279,
    y2: 419.6701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082350052280296307240000005383678690637586333_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.1724,
    y1: 419.6702,
    x2: 334.312,
    y2: 419.6702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000078757200373798029430000016010680524698398606_)",
      stroke: "url(#SVGID_00000082350052280296307240000005383678690637586333_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M333.73,417.6c-0.32,1.38-0.65,2.76-0.97,4.14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124155811073167908310000015934066712321673380_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.8848,
    y1: 419.0401,
    x2: 331.737,
    y2: 419.0401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#98C03D",
      stroke: "url(#SVGID_00000124155811073167908310000015934066712321673380_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M331.14,416.93c-0.22,1.41-0.44,2.81-0.67,4.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132795137577617109260000011783873669946473090_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.6956,
    y1: 418.4011,
    x2: 329.0629,
    y2: 418.4011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#98C03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000132795137577617109260000011783873669946473090_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M328.46,416.13c-0.06,1.51-0.11,3.02-0.17,4.53"
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 374.06,
    y1: 394.16,
    x2: 413.6,
    y2: 336.89
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 377.78,
    y1: 396.29,
    x2: 416.42,
    y2: 340.31
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 381.47,
    y1: 398.4,
    x2: 417.98,
    y2: 345.51
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 387.98,
    y1: 396.43,
    x2: 419.13,
    y2: 351.31
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 395,
    y1: 393.72,
    x2: 419.49,
    y2: 358.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 370.46,
    y1: 392.1,
    x2: 410,
    y2: 334.83
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 366.77,
    y1: 389.98,
    x2: 406.31,
    y2: 332.71
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 363.08,
    y1: 387.87,
    x2: 402.62,
    y2: 330.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 362.29,
    y1: 381.56,
    x2: 397.18,
    y2: 331.01
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 362,
    y1: 374.51,
    x2: 391.79,
    y2: 331.36
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 362.4,
    y1: 366.54,
    x2: 384.5,
    y2: 334.52
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 368.77,
    y1: 348.54,
    x2: 411.85,
    y2: 378.27
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 366.67,
    y1: 352.19,
    x2: 409.25,
    y2: 381.58
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 365.18,
    y1: 356.28,
    x2: 406.78,
    y2: 384.99
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 363.33,
    y1: 360.15,
    x2: 403.34,
    y2: 387.77
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 362.03,
    y1: 364.43,
    x2: 399.63,
    y2: 390.39
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 361.67,
    y1: 369.34,
    x2: 395.76,
    y2: 392.87
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 362.07,
    y1: 374.73,
    x2: 392.25,
    y2: 395.56
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 362.37,
    y1: 380.12,
    x2: 386.61,
    y2: 396.85
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 371.71,
    y1: 345.46,
    x2: 414.26,
    y2: 374.84
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 373.82,
    y1: 341.77,
    x2: 416.24,
    y2: 371.06
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 377.69,
    y1: 339.29,
    x2: 417.86,
    y2: 367.02
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 381.04,
    y1: 336.45,
    x2: 418.72,
    y2: 362.46
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 385.14,
    y1: 334.13,
    x2: 419.6,
    y2: 357.92
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 389.84,
    y1: 332.22,
    x2: 418.76,
    y2: 352.19
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st71",
    x1: 396,
    y1: 330.83,
    x2: 418.54,
    y2: 346.61
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170265914804982159180000016971534746828900513_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.6002,
    y1: 241.3952,
    x2: 422.4896,
    y2: 241.3952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031174405537643372790000010217756223182459552_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.6403,
    y1: 241.3952,
    x2: 423.4495,
    y2: 241.3952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#D09AC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000170265914804982159180000016971534746828900513_)",
      stroke: "url(#SVGID_00000031174405537643372790000010217756223182459552_)",
      strokeWidth: 1.9199,
      strokeMiterlimit: 22.9256
    },
    d: " M393.16,225.84c1-0.36,2.29-0.54,4.33,0.24c2.04,0.79,4.83,2.55,7.57,4.32c2.74,1.78,5.44,3.57,7.81,5.34 c2.37,1.78,4.41,3.54,5.97,5.06c1.56,1.52,2.64,2.81,3.21,4.14c0.57,1.33,0.63,2.71-0.05,4.31c-0.69,1.6-2.12,3.43-3.34,4.84 c-1.22,1.41-2.24,2.4-3.44,2.85c-1.2,0.45-2.57,0.36-4.03-0.02c-1.45-0.39-2.98-1.07-4.15-1.8c-1.17-0.73-1.98-1.51-2.42-2.81 c-0.44-1.3-0.5-3.13-0.5-4.47c0-1.35,0.06-2.22-0.17-2.96c-0.23-0.75-0.74-1.38-1.31-1.58c-0.57-0.21-1.2,0-1.81,0.18 c-0.61,0.18-1.21,0.33-1.99,0.54c-0.78,0.21-1.74,0.48-2.86,0.41c-1.12-0.07-2.41-0.49-3.82-1.34c-1.41-0.85-2.94-2.13-3.96-3.46 c-1.02-1.33-1.53-2.71-1.6-4.01c-0.06-1.3,0.32-2.53,1.08-3.91c0.76-1.38,1.89-2.91,2.82-3.94 C391.44,226.74,392.15,226.2,393.16,225.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064343252240562266560000005635423161294092685_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.6273,
    y1: 246.8497,
    x2: 415.0803,
    y2: 246.8497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000064343252240562266560000005635423161294092685_)",
      stroke: "#000000",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    x1: 415.08,
    y1: 236.93,
    x2: 410.63,
    y2: 256.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143609889195831015230000010045208933543710368_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.8763,
    y1: 245.1882,
    x2: 411.1138,
    y2: 245.1882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000143609889195831015230000010045208933543710368_)",
      stroke: "#000000",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    x1: 411.11,
    y1: 234.92,
    x2: 406.88,
    y2: 255.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031893423199022267790000001998392836624226698_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.9819,
    y1: 235.9456,
    x2: 400.2653,
    y2: 235.9456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000031893423199022267790000001998392836624226698_)",
      stroke: "#000000",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    x1: 400.27,
    y1: 227.45,
    x2: 395.98,
    y2: 244.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044878310596402663250000002546654768396923579_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.1619,
    y1: 234.3906,
    x2: 396.1723,
    y2: 234.3906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000044878310596402663250000002546654768396923579_)",
      stroke: "#000000",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    x1: 396.17,
    y1: 225.68,
    x2: 392.16,
    y2: 243.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122707263263396718010000017439178944813269413_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.7861,
    y1: 166.4789,
    x2: 369.6436,
    y2: 166.4789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#656EB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BF4B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000122707263263396718010000017439178944813269413_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M359.18,189.51c-1.05-1.28-2.37-4.25-3.64-7.47c-1.27-3.22-2.48-6.69-3.62-9.92c-1.14-3.23-2.2-6.22-3.79-10.55 c-1.59-4.32-3.71-9.98-4.7-12.97c-0.99-2.99-0.86-3.3,0.58-3.93c1.45-0.63,4.21-1.56,5.66-1.92c1.45-0.36,1.58-0.13,1.83,0.16 c0.25,0.29,0.63,0.64,1.77,0.55c1.14-0.09,3.05-0.61,4.06-0.81c1.01-0.2,1.11-0.09,0.96,2.71c-0.15,2.8-0.55,8.29-0.84,11.09 c-0.29,2.79-0.48,2.89-1.02,3.2c-0.54,0.31-1.44,0.82-2.02,1.36c-0.58,0.54-0.83,1.1-0.9,1.64c-0.07,0.54,0.04,1.05,0.35,1.56 c0.31,0.51,0.82,1.01,3.43,1.52c2.62,0.52,7.34,1.04,9.77,1.38c2.43,0.34,2.56,0.49,2.59,1.25c0.02,0.76-0.07,2.12-0.21,2.89 c-0.14,0.77-0.33,0.93-1.91,0.79c-1.58-0.14-4.54-0.59-6.46-0.8c-1.91-0.22-2.78-0.2-3.36-0.17c-0.58,0.03-0.87,0.09-1.16,0.3 c-0.28,0.22-0.56,0.59-0.6,1.2c-0.04,0.61,0.16,1.45,0.41,2.01c0.25,0.56,0.56,0.83,2.49,1.1c1.93,0.27,5.48,0.54,7.4,0.76 c1.91,0.22,2.19,0.38,2.27,0.89c0.07,0.51-0.05,1.37-0.33,1.98c-0.27,0.61-0.7,0.98-0.94,1.67c-0.24,0.69-0.31,1.69-0.38,2.54 c-0.07,0.84-0.15,1.52-0.8,2.09c-0.65,0.57-1.87,1.03-2.48,1.46s-0.6,0.83-0.58,1.19s0.03,0.69-0.17,0.96 c-0.2,0.28-0.61,0.5-1.21,0.82C361.01,190.37,360.23,190.79,359.18,189.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070117946010951923770000014307756315770440582_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.9682,
    y1: 152.528,
    x2: 370.8868,
    y2: 152.528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#7DC242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BF4B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000070117946010951923770000014307756315770440582_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M368.25,162.75c-2.03-0.39-5.97-1.33-8.04-1.92c-2.07-0.59-2.27-0.82-2.24-1.59c0.03-0.77,0.3-2.09,0.59-3.8 c0.29-1.71,0.61-3.82,0.83-6.08c0.22-2.26,0.34-4.67,0.48-5.9c0.14-1.24,0.28-1.3,0.88-1.35c0.6-0.05,1.65-0.09,2.23,0.11 c0.58,0.2,0.7,0.64,1.14,2.18c0.44,1.54,1.2,4.19,2.02,6.62c0.81,2.43,1.68,4.65,2.42,6.27c0.74,1.62,1.36,2.63,1.75,3.27 c0.39,0.64,0.55,0.9,0.58,1.08c0.02,0.18-0.09,0.28-0.17,0.46c-0.08,0.17-0.14,0.42-0.22,0.63 C370.4,162.96,370.28,163.14,368.25,162.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140728548702374137080000002325667124268180869_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.3889,
    y1: 146.9173,
    x2: 391.1076,
    y2: 146.9173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#656EB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BF4B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000140728548702374137080000002325667124268180869_)",
      stroke: "#000002",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M373.52,159.24c-0.99-1.9-2.43-5.79-3.34-7.9c-0.91-2.12-1.28-2.46-1.65-2.58c-0.37-0.11-0.74,0.01-1.06,0.22 c-0.32,0.21-0.59,0.52-0.7,0.78c-0.11,0.26-0.05,0.48-0.52-0.94c-0.47-1.42-1.45-4.48-1.76-6.07c-0.31-1.59,0.06-1.71,1.12-1.96 c1.06-0.25,2.82-0.64,4.25-1.09c1.44-0.45,2.55-0.95,3.54-1.44c0.99-0.49,1.85-0.98,3.22-1.57c1.37-0.59,3.26-1.3,4.52-1.52 c1.26-0.22,1.89,0.03,2.39,0.14c0.5,0.1,0.86,0.06,1.54-0.37c0.68-0.42,1.67-1.22,2.38-1.68c0.72-0.46,1.16-0.57,1.71-0.21 c0.55,0.36,1.22,1.2,1.28,3.89c0.06,2.69-0.49,7.23-0.61,9.84c-0.12,2.61,0.2,3.28,0.56,3.84c0.36,0.56,0.76,1.02,0.71,1.78 c-0.05,0.75-0.55,1.8-1.25,2.59c-0.7,0.78-1.6,1.3-2.46,1.79c-0.86,0.48-1.68,0.93-2.51,1.22c-0.83,0.29-1.67,0.41-2.58-1.32 c-0.91-1.74-1.9-5.34-2.5-7.45c-0.6-2.11-0.81-2.74-1.09-3.21c-0.28-0.47-0.62-0.78-1-0.95c-0.39-0.17-0.82-0.2-1.17-0.06 c-0.35,0.14-0.62,0.45-0.76,0.87c-0.14,0.42-0.14,0.96,0.28,3.14c0.42,2.17,1.25,5.98,1.67,8.04c0.42,2.07,0.44,2.39,0.26,2.65 c-0.18,0.26-0.55,0.45-0.98,0.66c-0.43,0.21-0.91,0.43-1.43,0.57C375.06,161.08,374.52,161.15,373.52,159.24z"
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st80",
    points: "382.64,157.46 382.69,158.22 378.92,159.71 378.31,159.02  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000201523824895469020000013668201880591361684_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.8309,
    y1: 161.5083,
    x2: 375.2104,
    y2: 161.5083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#7DC242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BF4B"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000000201523824895469020000013668201880591361684_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 375.15,160.39 375.21,161.15 371.43,162.63 370.83,161.94  "
  }), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st80",
    points: "370.39,163.03 371.07,163.37 370.46,167.37 369.56,167.55  "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st80",
    points: "368.85,172.27 369.56,172.55 369.23,176.59 368.35,176.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044137149102283328860000001809339292424812437_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.375,
    y1: 586.1816,
    x2: 295.1989,
    y2: 586.1816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155111578965071688930000010242217304527410057_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.1751,
    y1: 586.1816,
    x2: 296.3988,
    y2: 586.1816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000044137149102283328860000001809339292424812437_)",
      stroke: "url(#SVGID_00000155111578965071688930000010242217304527410057_)",
      strokeWidth: 2.3998,
      strokeMiterlimit: 22.9256
    },
    cx: 275.79,
    cy: 586.18,
    r: 19.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150807885416816604570000014622392145637862035_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.2817,
    y1: 577.5681,
    x2: 300.1057,
    y2: 577.5681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106143290821236115360000017245577298377912717_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0818,
    y1: 577.5681,
    x2: 301.3055,
    y2: 577.5681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000150807885416816604570000014622392145637862035_)",
      stroke: "url(#SVGID_00000106143290821236115360000017245577298377912717_)",
      strokeWidth: 2.3998,
      strokeMiterlimit: 22.9256
    },
    d: " M263.83,567.96c5.31-9.31,17.16-12.56,26.47-7.26c9.31,5.31,12.56,17.16,7.26,26.47c-5.31,9.31-17.16,12.56-26.47,7.26 C261.77,589.13,258.52,577.28,263.83,567.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106128624414521714880000015241427491974925441_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.9817,
    y1: 569.3176,
    x2: 304.8057,
    y2: 569.3176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176737341561493294720000000941218602934804139_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.7818,
    y1: 569.3176,
    x2: 306.0056,
    y2: 569.3176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    style: {
      stopColor: "#646CB2",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75C7A3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000106128624414521714880000015241427491974925441_)",
      stroke: "url(#SVGID_00000176737341561493294720000000941218602934804139_)",
      strokeWidth: 2.3998,
      strokeMiterlimit: 22.9256
    },
    cx: 285.39,
    cy: 569.32,
    r: 19.41
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M279.89,559.43l3.25,1.85c-1.68,0.72-3.04,1.76-4.08,3.12l4.3,2.45c1.42-1.33,2.86-2.14,4.33-2.46 c1.48-0.32,2.77-0.15,3.89,0.48c1.29,0.74,2.14,1.79,2.54,3.17c0.4,1.38,0.28,2.96-0.35,4.74l2.9,1.65l-1.26,2.21l-2.9-1.65 c-1.15,1.44-2.63,2.64-4.44,3.58l-3.11-1.77c2.14-0.91,3.75-2.02,4.84-3.35l-5.1-2.91c-2.57,2.77-5.16,3.41-7.77,1.92 c-1.2-0.68-1.99-1.71-2.38-3.07c-0.39-1.36-0.24-2.83,0.42-4.4l-0.95-0.54l1.26-2.21l0.95,0.54 C276.98,561.53,278.21,560.41,279.89,559.43L279.89,559.43z M281.29,568.6l-3.5-1.99c-0.38,1.34-0.15,2.25,0.69,2.73 C279.3,569.81,280.23,569.56,281.29,568.6L281.29,568.6z M286.65,568.73l4.33,2.47c0.46-1.53,0.15-2.6-0.93-3.21 C289.04,567.4,287.9,567.64,286.65,568.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163052080317690584020000002517109964730799272_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.1623,
    y1: 527.0084,
    x2: 325.5161,
    y2: 527.0084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067233612901807626400000014867054497214551470_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.8788,
    y1: 527.0084,
    x2: 325.7996,
    y2: 527.0084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000163052080317690584020000002517109964730799272_)",
      stroke: "url(#SVGID_00000067233612901807626400000014867054497214551470_)",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M298.04,500.88l25.58,8.82c1.47,0.51,2.25,2.12,1.75,3.58l-13.14,38.11c-0.51,1.47-2.12,2.25-3.58,1.75l-25.58-8.82 c-1.47-0.51-2.25-2.12-1.75-3.58l13.14-38.11C294.96,501.16,296.57,500.38,298.04,500.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039097454878839668940000002699117125367729838_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.4826,
    y1: 523.8391,
    x2: 296.8093,
    y2: 523.8391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133495596869055802920000017654755214112730002_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.0027,
    y1: 523.8391,
    x2: 297.2892,
    y2: 523.8391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000039097454878839668940000002699117125367729838_)",
      stroke: "url(#SVGID_00000133495596869055802920000017654755214112730002_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M293.99,521.25l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C292.45,521.39,293.26,521,293.99,521.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095317583158047435960000000953692209846557589_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.8646,
    y1: 531.4331,
    x2: 294.1912,
    y2: 531.4331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129201002479881404860000003846728532538345376_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.3847,
    y1: 531.4331,
    x2: 294.6711,
    y2: 531.4331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000095317583158047435960000000953692209846557589_)",
      stroke: "url(#SVGID_00000129201002479881404860000003846728532538345376_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M291.38,528.85l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C289.84,528.99,290.64,528.59,291.38,528.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083082406400325681030000016996241795047932840_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.2005,
    y1: 539.1609,
    x2: 291.5271,
    y2: 539.1609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150095302295244923670000014586075530076200113_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.7206,
    y1: 539.1609,
    x2: 292.007,
    y2: 539.1609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000083082406400325681030000016996241795047932840_)",
      stroke: "url(#SVGID_00000150095302295244923670000014586075530076200113_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M288.71,536.57l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C287.17,536.71,287.98,536.32,288.71,536.57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141421725596498245980000016578798112394834613_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.6759,
    y1: 527.0083,
    x2: 306.0025,
    y2: 527.0083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158740884914324617030000013078749903280222648_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.196,
    y1: 527.0083,
    x2: 306.4824,
    y2: 527.0083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000141421725596498245980000016578798112394834613_)",
      stroke: "url(#SVGID_00000158740884914324617030000013078749903280222648_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M303.19,524.42l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C301.65,524.56,302.45,524.17,303.19,524.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104700482271991065930000014053521006875044228_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0578,
    y1: 534.6025,
    x2: 303.3845,
    y2: 534.6025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023262170246413299360000011369033593968239278_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.5779,
    y1: 534.6025,
    x2: 303.8644,
    y2: 534.6025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000104700482271991065930000014053521006875044228_)",
      stroke: "url(#SVGID_00000023262170246413299360000011369033593968239278_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M300.57,532.02l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C299.03,532.16,299.84,531.76,300.57,532.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002366137248681811190000001935285864290339997_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.3937,
    y1: 542.3303,
    x2: 300.7204,
    y2: 542.3303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121980923981126478150000012442888556940358273_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.9138,
    y1: 542.3303,
    x2: 301.2003,
    y2: 542.3303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000002366137248681811190000001935285864290339997_)",
      stroke: "url(#SVGID_00000121980923981126478150000012442888556940358273_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M297.91,539.74l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C296.37,539.88,297.17,539.49,297.91,539.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105402423878583306560000003423584210468090287_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.0022,
    y1: 530.2236,
    x2: 315.3289,
    y2: 530.2236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054250038515738893410000008012562931816852649_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.5222,
    y1: 530.2236,
    x2: 315.8088,
    y2: 530.2236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000105402423878583306560000003423584210468090287_)",
      stroke: "url(#SVGID_00000054250038515738893410000008012562931816852649_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M312.51,527.64l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C310.97,527.78,311.78,527.38,312.51,527.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159469693612129862100000007498428475295735201_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.3842,
    y1: 537.8176,
    x2: 312.7108,
    y2: 537.8176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089570850608050751350000011709098694303036056_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.9043,
    y1: 537.8176,
    x2: 313.1907,
    y2: 537.8176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000159469693612129862100000007498428475295735201_)",
      stroke: "url(#SVGID_00000089570850608050751350000011709098694303036056_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M309.9,535.23l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C308.36,535.37,309.16,534.98,309.9,535.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026844596122126772240000013351227094791126951_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.7201,
    y1: 545.5455,
    x2: 310.0468,
    y2: 545.5455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122701192843107326810000003168191951862221483_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.2402,
    y1: 545.5455,
    x2: 310.5267,
    y2: 545.5455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000026844596122126772240000013351227094791126951_)",
      stroke: "url(#SVGID_00000122701192843107326810000003168191951862221483_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M307.23,542.96l1.87,0.64c0.73,0.25,1.13,1.06,0.87,1.79l-0.64,1.87c-0.25,0.73-1.06,1.13-1.79,0.87l-1.87-0.64 c-0.73-0.25-1.13-1.06-0.87-1.79l0.64-1.87C305.69,543.1,306.5,542.71,307.23,542.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156557964462352982540000003042969297910333626_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.1466,
    y1: 515.4169,
    x2: 320.5239,
    y2: 515.4169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140715389478477696110000002473759950731734424_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.6667,
    y1: 515.4169,
    x2: 321.0038,
    y2: 515.4169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000156557964462352982540000003042969297910333626_)",
      stroke: "url(#SVGID_00000140715389478477696110000002473759950731734424_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M299.32,505.8l20.25,6.98c0.73,0.25,1.13,1.06,0.87,1.79l-3.31,9.59c-0.25,0.73-1.06,1.13-1.79,0.87l-20.25-6.98 c-0.73-0.25-1.13-1.06-0.87-1.79l3.31-9.59C297.78,505.94,298.59,505.54,299.32,505.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129192089374519672280000012325355374010165166_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.7505,
    y1: 273.0634,
    x2: 379.3864,
    y2: 273.0634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000129192089374519672280000012325355374010165166_)"
    },
    points: " 375.35,267.47 379.39,273.84 371.79,278.66 367.75,272.29  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089561954352637485960000005530134788015772554_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.5467,
    y1: 268.9608,
    x2: 383.5273,
    y2: 268.9608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000089561954352637485960000005530134788015772554_)"
    },
    points: " 381.89,265.97 383.53,268.56 378.19,271.95 376.55,269.36  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110433043470973299310000001883774166493171625_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.207,
    y1: 275.2599,
    x2: 368.7775,
    y2: 275.2599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000110433043470973299310000001883774166493171625_)"
    },
    points: " 368.78,271.64 349.02,274.09 348.58,272.93 346.13,273.62 346.11,274.5 337.59,275.58 337.16,276.72 334.21,278.88 337.81,277.75  368.68,273.75 367.75,272.29  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031171766286905585490000013157302139084590209_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.4847,
    y1: 291.6223,
    x2: 372.7692,
    y2: 291.6223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000031171766286905585490000013157302139084590209_)"
    },
    points: " 372.77,277.93 362.13,294.76 362.99,295.65 361.33,297.57 360.52,297.22 355.91,304.47 354.7,304.37 351.48,306.12 354.04,303.34  370.82,277.12 371.74,278.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103244341161534620340000012411405427984691375_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.2964,
    y1: 292.5862,
    x2: 352.4043,
    y2: 292.5862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000103244341161534620340000012411405427984691375_)"
    },
    points: " 351.35,285.5 348.47,287.24 337.89,284.64 336.3,285.6 345.33,300.53 347,299.52 349.6,288.94 352.4,287.25  "
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M348.44,289.75l-1.45,7.66c-0.04,0.24-0.28,0.4-0.52,0.35l0,0c-0.24-0.05-0.4-0.28-0.35-0.52l1.45-7.66 c0.05-0.24,0.28-0.4,0.52-0.35l0,0C348.32,289.28,348.48,289.51,348.44,289.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002356666531877702470000001601654661367517631_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.6914,
    y1: 290.5765,
    x2: 362.4468,
    y2: 290.5765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#A95C26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#DEE21D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#FCEE2D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000002356666531877702470000001601654661367517631_)",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 358.43,278.73 349.49,284.14 348.43,284.78 337.94,281.81 336.54,282.24 335.27,283.22 334.48,284.32 334.31,286.08 334.67,286.69  343.66,301.54 344.76,302.33 345.97,302.63 347.22,302.29 348.58,301.46 349.16,300.7 351.94,289.91 361.62,284.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067938423814864866400000000476911585573077398_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.2804,
    y1: 250.2288,
    x2: 358.4822,
    y2: 250.2288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000067938423814864866400000000476911585573077398_)",
      stroke: "#000000",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M334.29,260.02c-0.05-4.84,0.13-14.09,0.26-18.89c0.13-4.8,0.2-5.14,0.34-5.51c0.14-0.37,0.36-0.78,0.64-1.12 c0.28-0.34,0.63-0.61,0.94-0.81c0.31-0.2,0.59-0.33,3.88-0.34c3.29-0.01,9.6,0.11,12.85,0.21c3.26,0.1,3.46,0.17,3.63,0.24 c0.17,0.07,0.31,0.14,0.51,0.35c0.2,0.21,0.47,0.56,0.7,0.9c0.23,0.35,0.43,0.69,0.44,5.7c0.01,5.01-0.18,14.67-0.34,19.67 c-0.16,5-0.31,5.34-0.59,5.68c-0.28,0.34-0.7,0.67-1.04,0.84c-0.35,0.16-0.62,0.16-3.91,0.1c-3.29-0.06-9.6-0.18-12.92-0.28 c-3.32-0.1-3.67-0.17-3.97-0.35c-0.31-0.18-0.57-0.46-0.84-0.8C334.6,265.28,334.33,264.86,334.29,260.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140706946471438766390000004569168546881561769_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.2683,
    y1: 242.755,
    x2: 354.2552,
    y2: 242.755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000140706946471438766390000004569168546881561769_)",
      stroke: "#FFFFFF",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    d: " M348.88,242.73c-0.02,0.17-0.11,0.34-0.2,0.53c-0.09,0.19-0.18,0.4-0.25,0.61c-0.07,0.21-0.11,0.43-0.14,0.7 c-0.03,0.28-0.03,0.62,0,0.94c0.04,0.32,0.12,0.62,0.28,0.88c0.17,0.26,0.42,0.48,0.69,0.7c0.27,0.22,0.57,0.44,0.91,0.57 c0.34,0.13,0.72,0.18,1.13,0.17c0.41-0.01,0.83-0.09,1.22-0.25c0.39-0.16,0.73-0.41,1-0.69c0.26-0.27,0.44-0.57,0.53-0.87 c0.09-0.3,0.1-0.6,0.06-0.96c-0.04-0.36-0.11-0.79-0.21-1.18c-0.1-0.39-0.22-0.73-0.26-0.99c-0.04-0.26,0.01-0.43,0.1-0.7 c0.09-0.28,0.23-0.66,0.34-1c0.11-0.34,0.2-0.64,0.17-1.04c-0.04-0.41-0.2-0.92-0.47-1.31c-0.27-0.39-0.65-0.65-1.01-0.83 c-0.36-0.18-0.7-0.27-1.08-0.32c-0.38-0.05-0.81-0.06-1.22,0.06c-0.41,0.12-0.8,0.37-1.1,0.68c-0.3,0.31-0.53,0.7-0.7,1.1 c-0.18,0.4-0.31,0.83-0.34,1.17c-0.03,0.34,0.05,0.6,0.15,0.84c0.1,0.24,0.23,0.45,0.31,0.65 C348.87,242.39,348.91,242.56,348.88,242.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043429692664075027670000002755329647159252413_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.4621,
    y1: 250.0555,
    x2: 338.9885,
    y2: 250.0555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000043429692664075027670000002755329647159252413_)",
      stroke: "#FFFFFF",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    x1: 338.46,
    y1: 266.74,
    x2: 338.99,
    y2: 233.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090984566085085586070000004086648614413220499_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.8347,
    y1: 250.2136,
    x2: 342.3878,
    y2: 250.2136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4954A4"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000090984566085085586070000004086648614413220499_)",
      stroke: "#FFFFFF",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    x1: 341.83,
    y1: 267.06,
    x2: 342.39,
    y2: 233.37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162316371819128719390000005278989312228523665_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.48,
    y1: 213.03,
    x2: 360.5737,
    y2: 213.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000162316371819128719390000005278989312228523665_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    points: " 336.25,196.9 360.57,197.5 359.8,229.16 335.48,228.56  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037680565117438050320000016611337287306463410_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.4916,
    y1: 196.4656,
    x2: 353.2663,
    y2: 196.4656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000037680565117438050320000016611337287306463410_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    points: " 343.52,195.82 353.27,196.06 353.24,197.11 343.49,196.87  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035523749530014119840000007650001298167613367_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.0507,
    y1: 195.1041,
    x2: 350.7575,
    y2: 195.1041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000035523749530014119840000007650001298167613367_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.5669,
      strokeMiterlimit: 22.9256
    },
    d: " M346.06,195.55c-0.01-0.12-0.01-0.26,0.03-0.4c0.04-0.14,0.11-0.28,0.26-0.41c0.14-0.14,0.36-0.27,0.59-0.37 c0.23-0.1,0.48-0.16,0.93-0.2c0.46-0.04,1.12-0.06,1.56-0.01c0.44,0.05,0.64,0.16,0.8,0.3c0.15,0.14,0.25,0.32,0.34,0.48 c0.08,0.16,0.15,0.3,0.18,0.44c0.03,0.14,0.03,0.28,0.02,0.42c0,0.14-0.01,0.28-0.78,0.3c-0.77,0.02-2.31-0.09-3.09-0.2 C346.1,195.78,346.07,195.68,346.06,195.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138566727530688516960000015251553673161331093_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5579,
    y1: 197.8795,
    x2: 353.031,
    y2: 197.8795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000138566727530688516960000015251553673161331093_)",
      stroke: "#FFFFFF",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 343.59,197.08 343.56,198.45 352.99,198.68 353.03,197.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000922047922055861410000006734238427717930396_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.37,
    y1: 204.7379,
    x2: 340.0472,
    y2: 204.7379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000000922047922055861410000006734238427717930396_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 338.37,
    y1: 204.72,
    x2: 340.05,
    y2: 204.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152977570878811411750000017031874969406854844_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.5632,
    y1: 204.9834,
    x2: 355.9816,
    y2: 204.9834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000152977570878811411750000017031874969406854844_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 342.56,
    y1: 204.82,
    x2: 355.98,
    y2: 205.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093868148019181664520000009034806883976237442_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.2676,
    y1: 208.9307,
    x2: 339.9449,
    y2: 208.9307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000093868148019181664520000009034806883976237442_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 338.27,
    y1: 208.91,
    x2: 339.94,
    y2: 208.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100358803098156651360000006896121323634309559_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.4609,
    y1: 209.1765,
    x2: 355.879,
    y2: 209.1765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000100358803098156651360000006896121323634309559_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 342.46,
    y1: 209.01,
    x2: 355.88,
    y2: 209.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001665115743900511540000008978295042059439507_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.1653,
    y1: 213.1237,
    x2: 339.8426,
    y2: 213.1237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000001665115743900511540000008978295042059439507_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 338.17,
    y1: 213.1,
    x2: 339.84,
    y2: 213.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161622404193515182210000017581523423935669895_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.3583,
    y1: 213.3694,
    x2: 355.7767,
    y2: 213.3694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000161622404193515182210000017581523423935669895_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 342.36,
    y1: 213.21,
    x2: 355.78,
    y2: 213.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181794036134808938550000007195845551221883011_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.063,
    y1: 217.3172,
    x2: 339.7402,
    y2: 217.3172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000181794036134808938550000007195845551221883011_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 338.06,
    y1: 217.3,
    x2: 339.74,
    y2: 217.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071532385461593189730000007095184628041131199_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.256,
    y1: 217.5627,
    x2: 355.6743,
    y2: 217.5627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4DA1"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000071532385461593189730000007095184628041131199_)",
      stroke: "#FFFFFF",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    x1: 342.26,
    y1: 217.4,
    x2: 355.67,
    y2: 217.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004545470855846780240000009120830205524896679_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.1333,
    y1: 474.5998,
    x2: 392.688,
    y2: 474.5998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000004545470855846780240000009120830205524896679_)",
      stroke: "#000000",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 385.33,479.68 383.13,472.34 384.27,470.68 386.82,469.81 389.26,469.52 391.01,469.88 392.69,471.2 392.64,478.81  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182513572654670507400000004223802367071751325_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.9168,
    y1: 477.7878,
    x2: 392.6503,
    y2: 477.7878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000182513572654670507400000004223802367071751325_)",
      stroke: "#000000",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 384.92,478.28 392.63,477.29 392.65,477.29  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122697584690158605200000007630339725986520722_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.2911,
    y1: 451.4342,
    x2: 392.7441,
    y2: 451.4342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000122697584690158605200000007630339725986520722_)"
    },
    points: " 382.58,471.12 378.29,434.96 379.78,433.08 382.12,432.04 384.56,431.75 386.85,431.86 388.27,432.64 392.74,470.29 391.67,469.28  388.57,468.7 385.38,469.08 383.41,470.07  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096042050939943637720000002983972086270009526_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.8264,
    y1: 443.2164,
    x2: 388.9845,
    y2: 443.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000096042050939943637720000002983972086270009526_)"
    },
    points: " 381.3,449.9 382.88,448.77 382.99,448.7 385.08,448.12 387.75,448.19 388.98,448.99 387.61,437.38 386.58,436.74 383.52,436.53  383.45,436.63 380.79,437.61 379.83,439.06 381.3,449.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102531806227565481840000011587117135602533307_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.2982,
    y1: 465.0626,
    x2: 391.1666,
    y2: 465.0626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000102531806227565481840000011587117135602533307_)"
    },
    points: " 383.3,466.52 384.9,465.58 387.1,464.93 389.77,465 391.17,465.59 391.06,464.65 390.01,463.83 387.13,463.6 384.57,464.47  383.37,465.57  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092453773699945299920000016620813616949764503_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.2811,
    y1: 450.011,
    x2: 404.7341,
    y2: 450.011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000092453773699945299920000016620813616949764503_)"
    },
    points: " 394.57,469.7 390.28,433.54 391.77,431.65 394.11,430.61 396.55,430.33 398.84,430.43 400.26,431.21 404.73,468.87 403.66,467.86  400.56,467.28 397.37,467.65 395.4,468.65  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178162878903448712450000009589706928005144201_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.8163,
    y1: 441.8512,
    x2: 400.9748,
    y2: 441.8512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000178162878903448712450000009589706928005144201_)"
    },
    points: " 393.29,448.48 394.87,447.34 394.98,447.28 397.07,446.7 399.74,446.76 400.97,447.57 399.6,435.95 398.57,435.31 395.51,435.11  395.44,435.21 392.78,436.19 391.82,437.64 393.12,448.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134961128450428871160000010554609513415036294_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.2882,
    y1: 463.6393,
    x2: 403.1566,
    y2: 463.6393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000134961128450428871160000010554609513415036294_)"
    },
    points: " 395.29,465.1 396.89,464.15 399.09,463.51 401.76,463.57 403.16,464.17 403.05,463.23 402,462.41 399.12,462.18 396.56,463.05  395.36,464.14  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105407121848460360540000007694264324286304397_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.6793,
    y1: 473.3274,
    x2: 404.3256,
    y2: 473.3274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000105407121848460360540000007694264324286304397_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 394.68,478.38 394.7,470.59 396.26,469.26 399.75,468.28 403.21,468.63 404.33,470.01 401.99,477.51  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121277566944224339510000015166049712387099820_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.683,
    y1: 476.7538,
    x2: 402.3609,
    y2: 476.7538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000121277566944224339510000015166049712387099820_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 394.68,477.22 395.22,477.12 402.29,476.29 402.36,476.31  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025431884498453528770000005315605710973616277_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.6941,
    y1: 472.3791,
    x2: 415.8428,
    y2: 472.3791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000025431884498453528770000005315605710973616277_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 403.69,477.5 407.21,468.72 409.75,467.66 413.12,467.26 415.29,467.95 415.84,469.41 411.02,476.82  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159467154210683525350000007148742115029946755_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.2576,
    y1: 475.6222,
    x2: 412.1898,
    y2: 475.6222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000159467154210683525350000007148742115029946755_)",
      stroke: "#000002",
      strokeWidth: 1.1999,
      strokeMiterlimit: 22.9256
    },
    points: " 404.26,476.09 412.19,475.15 412.19,475.15  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046339977632061699740000013597019943293709471_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.084,
    y1: 448.6101,
    x2: 416.537,
    y2: 448.6101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000046339977632061699740000013597019943293709471_)"
    },
    points: " 406.38,468.3 402.08,432.14 403.57,430.25 405.92,429.21 408.35,428.92 410.64,429.03 412.07,429.81 416.54,467.47 415.47,466.46  412.36,465.88 409.17,466.25 407.2,467.25  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168082959101116043930000007015474625099775628_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.6192,
    y1: 440.4504,
    x2: 412.7774,
    y2: 440.4504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000168082959101116043930000007015474625099775628_)"
    },
    points: " 405.1,447.08 406.67,445.94 406.78,445.88 408.88,445.3 411.54,445.36 412.78,446.17 411.4,434.55 410.37,433.91 407.31,433.71  407.25,433.81 404.59,434.79 403.62,436.23 404.92,447.19  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064337411531918268520000002401162173756863660_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.0908,
    y1: 462.2385,
    x2: 414.9595,
    y2: 462.2385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000064337411531918268520000002401162173756863660_)"
    },
    points: " 407.09,463.7 408.69,462.75 410.89,462.11 413.56,462.17 414.96,462.77 414.85,461.83 413.8,461 410.92,460.78 408.37,461.65  407.17,462.74  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142865754690114345010000006737068413297220796_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.3611,
    y1: 179.701,
    x2: 429.8022,
    y2: 179.701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384EA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000142865754690114345010000006737068413297220796_)"
    },
    d: " M392.28,143.24c-0.24,0.88-0.32,2.8-0.04,4.2c0.28,1.4,0.92,2.28,1.28,2.96c0.36,0.68,0.44,1.16,0.24,2.04 c-0.2,0.88-0.68,2.16-1.68,3.24c-1,1.08-2.52,1.96-3.24,2.52c-0.72,0.56-0.64,0.8,0.32,0.52c0.96-0.28,2.8-1.08,5-1.56 c2.2-0.48,4.76-0.64,7.44-0.32c2.68,0.32,5.48,1.12,7.96,2.2s4.64,2.44,6.48,3.96c1.84,1.52,3.36,3.2,4.64,5.04 c1.28,1.84,2.32,3.84,2.92,6.2c0.6,2.36,0.76,5.08,0.88,12.2c0.12,7.12,0.2,18.64,0.32,26.24c0.12,7.6,0.28,11.28,1.48,6.8 c1.2-4.48,3.44-17.12,3.52-27.52c0.08-10.4-2-18.56-4-23.84c-2-5.28-3.92-7.68-7.32-11.64c-3.4-3.96-8.28-9.48-11.72-12.92 c-3.44-3.44-5.44-4.8-6.56-5.32c-1.12-0.52-1.36-0.2-1.36,0.4c0,0.6,0.24,1.48,0.16,2.2c-0.08,0.72-0.48,1.28-1.12,1.56 c-0.64,0.28-1.52,0.28-2.32,0.28c-0.8,0-1.52,0-2.08-0.08C392.92,142.52,392.52,142.36,392.28,143.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121973782064067302190000012580215572788611513_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.7369,
    y1: 215.3174,
    x2: 423.8802,
    y2: 215.3174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000121973782064067302190000012580215572788611513_)"
    },
    d: " M423.52,196.8c0.2,8.68,0.36,26.84,0.36,35.92c0,9.08-0.16,9.08-1,8.28c-0.84-0.8-2.36-2.4-4.4-4.2c-2.04-1.8-4.6-3.8-6.08-5.04 c-1.48-1.24-1.88-1.72-1.56-2c0.32-0.28,1.36-0.36,2.36-0.68c1-0.32,1.96-0.88,2.76-1.72c0.8-0.84,1.44-1.96,1.72-3.08 c0.28-1.12,0.2-2.24-0.08-3.64c-0.28-1.4-0.76-3.08-1.4-4.52c-0.64-1.44-1.44-2.64-2.2-3.68c-0.76-1.04-1.48-1.92-1.76-2.52 c-0.28-0.6-0.12-0.92,0.84-2.12c0.96-1.2,2.72-3.28,4.36-5.88c1.64-2.6,3.16-5.72,4.04-7.84c0.88-2.12,1.12-3.24,1.36-4.2 C423.08,188.92,423.32,188.12,423.52,196.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109712442530694741060000005738556356737833372_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.7967,
    y1: 205.2813,
    x2: 384.3806,
    y2: 205.2813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000109712442530694741060000005738556356737833372_)"
    },
    d: " M374.36,198.28c1.12,3.36,2.96,8.32,4.16,12.04c1.2,3.72,1.76,6.2,2.16,7.36c0.4,1.16,0.64,1,0.96,0.2c0.32-0.8,0.72-2.24,1.24-3.52 c0.52-1.28,1.16-2.4,1.4-3.08c0.24-0.68,0.08-0.92-0.8-2.04c-0.88-1.12-2.48-3.12-3.96-5.28c-1.48-2.16-2.84-4.48-3.84-6.44 c-1-1.96-1.64-3.56-2.12-4.52c-0.48-0.96-0.8-1.28-0.76-0.56C372.84,193.16,373.24,194.92,374.36,198.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090270929708978172810000003123687351699549620_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.3451,
    y1: 251.6324,
    x2: 403.4529,
    y2: 251.6324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4737,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    style: {
      stopColor: "#2168B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000090270929708978172810000003123687351699549620_)"
    },
    d: " M385.72,244.64c0.4,3.48,1.12,9.56,1.48,13.08c0.36,3.52,0.36,4.48,0.44,4.96c0.08,0.48,0.24,0.48,0.72-0.12 c0.48-0.6,1.28-1.8,2.44-2.8c1.16-1,2.68-1.8,4.44-2.4c1.76-0.6,3.76-1,5.16-1.2c1.4-0.2,2.2-0.2,2.64-0.36 c0.44-0.16,0.52-0.48,0.28-0.88c-0.24-0.4-0.8-0.88-1.2-1.76c-0.4-0.88-0.64-2.16-0.76-3.28c-0.12-1.12-0.12-2.08-0.2-2.6 c-0.08-0.52-0.24-0.6-0.8-0.56c-0.56,0.04-1.52,0.2-2.64,0.28c-1.12,0.08-2.4,0.08-3.8-0.32c-1.4-0.4-2.92-1.2-4.12-2.08 c-1.2-0.88-2.08-1.84-2.8-2.72c-0.72-0.88-1.28-1.68-1.52-1.64C385.24,240.28,385.32,241.16,385.72,244.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151501840529178814270000011051806206539062676_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.8293,
    y1: 277.5939,
    x2: 423.6909,
    y2: 277.5939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000151501840529178814270000011051806206539062676_)"
    },
    d: " M414.84,261.28c0.56,0.68,1.52,1.64,2.28,3c0.76,1.36,1.32,3.12,1.72,4.88c0.4,1.76,0.64,3.52,0.64,5.24c0,1.72-0.24,3.4-0.68,5 c-0.44,1.6-1.08,3.12-2.08,4.68c-1,1.56-2.36,3.16-4,4.32c-1.64,1.16-3.56,1.88-5.56,2.44c-2,0.56-4.08,0.96-5.48,1.04 c-1.4,0.08-2.12-0.16-2.52-0.24c-0.4-0.08-0.48,0,0,0.84c0.48,0.84,1.52,2.44,2.76,4.6c1.24,2.16,2.68,4.88,3.72,5.96 c1.04,1.08,1.68,0.52,3.08-1.04c1.4-1.56,3.56-4.12,5.6-6.72c2.04-2.6,3.96-5.24,5.44-7.52c1.48-2.28,2.52-4.2,3.08-6.6 c0.56-2.4,0.64-5.28,0.68-9.24c0.04-3.96,0.04-9,0.08-12.6c0.04-3.6,0.12-5.76,0.08-6.84c-0.04-1.08-0.2-1.08-0.6-0.52 c-0.4,0.56-1.04,1.68-1.88,2.96c-0.84,1.28-1.88,2.72-2.76,3.6c-0.88,0.88-1.6,1.2-2.32,1.32c-0.72,0.12-1.44,0.04-1.72,0.2 C414.12,260.2,414.28,260.6,414.84,261.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141415863862398168890000015079456052558365332_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.941,
    y1: 277.2981,
    x2: 387.8195,
    y2: 277.2981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000141415863862398168890000015079456052558365332_)"
    },
    d: " M379.96,278.56c0.16-0.92,1.36-2.52,2.48-4c1.12-1.48,2.16-2.84,2.68-3.36c0.52-0.52,0.52-0.2,0.44,0.88 c-0.08,1.08-0.24,2.92-0.16,4.68c0.08,1.76,0.4,3.44,0.92,4.56c0.52,1.12,1.24,1.68,1.44,2c0.2,0.32-0.12,0.4-0.72,0.24 c-0.6-0.16-1.48-0.56-2.44-1.2c-0.96-0.64-2-1.52-2.96-2.08C380.68,279.72,379.8,279.48,379.96,278.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063633095228377077370000007711442291481902474_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.73,
    y1: 132.2797,
    x2: 388.9732,
    y2: 132.2797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    style: {
      stopColor: "#3A53A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#47C7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#46B5E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000063633095228377077370000007711442291481902474_)"
    },
    d: " M356.52,140.36c1.52-0.88,5.36-2.64,9.24-4.8s7.8-4.72,10.72-6.96c2.92-2.24,4.84-4.16,6.12-4.84c1.28-0.68,1.92-0.12,2.96,1.24 c1.04,1.36,2.48,3.52,3.08,4.64c0.6,1.12,0.36,1.2-0.48,1.6c-0.84,0.4-2.28,1.12-3.36,1.52c-1.08,0.4-1.8,0.48-3,0.84 c-1.2,0.36-2.88,1-5.52,1.88c-2.64,0.88-6.24,2-9.68,3c-3.44,1-6.72,1.88-8.76,2.32C355.8,141.24,355,141.24,356.52,140.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024685828216088971910000003180112593109051829_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.9558,
    y1: 178.4127,
    x2: 360.2238,
    y2: 178.4127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000024685828216088971910000003180112593109051829_)"
    },
    d: " M345.6,163.56c-0.12,1.76-0.2,4.96-0.88,8.68c-0.68,3.72-1.96,7.96-3.28,11.52c-1.32,3.56-2.68,6.44-3.48,8.16 c-0.8,1.72-1.04,2.28-1,2.56c0.04,0.28,0.36,0.28,1.28,0.32c0.92,0.04,2.44,0.12,3.28-0.08c0.84-0.2,1-0.68,1.32-0.96 c0.32-0.28,0.8-0.36,1.36-0.6c0.56-0.24,1.2-0.64,1.92-0.84c0.72-0.2,1.52-0.2,2.52-0.2c1,0,2.2,0,2.88,0.2 c0.68,0.2,0.84,0.6,1.36,0.88c0.52,0.28,1.4,0.44,1.84,0.76c0.44,0.32,0.44,0.8,1.28,1.04c0.84,0.24,2.52,0.24,3.4-0.28 c0.88-0.52,0.96-1.56,0.68-2.16c-0.28-0.6-0.92-0.76-1.6-1.44c-0.68-0.68-1.4-1.88-2.88-4.84c-1.48-2.96-3.72-7.68-5.24-11.72 c-1.52-4.04-2.32-7.4-2.92-9.52c-0.6-2.12-1-3-1.28-3.28C345.88,161.48,345.72,161.8,345.6,163.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125592684012652030820000004417292978528571788_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.394,
    y1: 234.8319,
    x2: 386.0399,
    y2: 234.8319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#A0CC3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CCC93"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023255121381293931370000011932224397347980219_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.894,
    y1: 234.8319,
    x2: 386.5399,
    y2: 234.8319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#A0CC3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CCC93"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000125592684012652030820000004417292978528571788_)",
      stroke: "url(#SVGID_00000023255121381293931370000011932224397347980219_)",
      strokeMiterlimit: 10
    },
    d: " M374.44,215.68c0.08,10.36,0.24,29.4,0.4,38.92c0.16,9.52,0.32,9.52,0.64,9.96c0.32,0.44,0.8,1.32,1.92,1.16 c1.12-0.16,2.88-1.36,3.88-1.92c1-0.56,1.24-0.48,1.64,0c0.4,0.48,0.96,1.36,1.4,1.64c0.44,0.28,0.76-0.04,1.08-0.4 c0.32-0.36,0.64-0.76,0.64-2.48s-0.32-4.76-0.88-9.96c-0.56-5.2-1.36-12.56-2.32-18.36c-0.96-5.8-2.08-10.04-3.24-14 c-1.16-3.96-2.36-7.64-3.24-10.64c-0.88-3-1.44-5.32-1.72-5.64C374.36,203.64,374.36,205.32,374.44,215.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163752422369224653250000013553577298027504019_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.5567,
    y1: 313.9822,
    x2: 354.235,
    y2: 313.9822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000163752422369224653250000013553577298027504019_)"
    },
    d: " M333.6,295.16c-0.12,4.24,0.04,12.88,0.12,20.72c0.08,7.84,0.08,14.88,0.28,18.16c0.2,3.28,0.6,2.8,1.4,1.52 c0.8-1.28,2-3.36,3.32-5.48c1.32-2.12,2.76-4.28,4.08-5.64c1.32-1.36,2.52-1.92,3.4-2.72c0.88-0.8,1.44-1.84,2.8-4.28 c1.36-2.44,3.52-6.28,4.52-8.32s0.84-2.28,0.2-2.08c-0.64,0.2-1.76,0.84-2.64,0.4c-0.88-0.44-1.52-1.96-2.04-2.72 c-0.52-0.76-0.92-0.76-1.56-0.44c-0.64,0.32-1.52,0.96-2.32,1.04c-0.8,0.08-1.52-0.4-2.84-2.12c-1.32-1.72-3.24-4.68-4.64-6.88 c-1.4-2.2-2.28-3.64-2.92-4.44C334.12,291.08,333.72,290.92,333.6,295.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112606538779600299940000013983317472957759641_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.0726,
    y1: 327.9453,
    x2: 422.9311,
    y2: 327.9453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384EA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000112606538779600299940000013983317472957759641_)"
    },
    d: " M411.64,302.8c-1.36,1.24-3.84,4.2-6.84,7.28c-3,3.08-6.52,6.28-10.8,9.56c-4.28,3.28-9.32,6.64-11.76,8.56 c-2.44,1.92-2.28,2.4-2.04,3c0.24,0.6,0.56,1.32,1.08,1.56c0.52,0.24,1.24,0,2.72-0.68c1.48-0.68,3.72-1.8,6.44-2.6 c2.72-0.8,5.92-1.28,8.76-1.4c2.84-0.12,5.32,0.12,7.6,0.84c2.28,0.72,4.36,1.92,6.16,3.24c1.8,1.32,3.32,2.76,4.48,4.44 c1.16,1.68,1.96,3.6,2.6,5.72c0.64,2.12,1.12,4.44,1.36,6.44c0.24,2,0.24,3.68,0.32,4.52c0.08,0.84,0.24,0.84,0.48-0.16 c0.24-1,0.56-3,0.68-6.2c0.12-3.2,0.04-7.6-0.36-11.68s-1.12-7.84-2.16-11.64c-1.04-3.8-2.4-7.64-3.56-11.04 c-1.16-3.4-2.12-6.36-2.64-7.96c-0.52-1.6-0.6-1.84-0.76-2.2C413.24,302.04,413,301.56,411.64,302.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076572204215720545620000013721958088810441628_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.47,
    y1: 343.5334,
    x2: 368.3867,
    y2: 343.5334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000076572204215720545620000013721958088810441628_)"
    },
    d: " M345.6,325.6c-1.16,1-2.76,2.52-4.2,4.24c-1.44,1.72-2.72,3.64-3.76,5.44c-1.04,1.8-1.84,3.48-2.56,5.36 c-0.72,1.88-1.36,3.96-1.96,6.24c-0.6,2.28-1.16,4.76-1.44,6.4c-0.28,1.64-0.28,2.44,0,3.16c0.28,0.72,0.84,1.36,1.68,2.12 c0.84,0.76,1.96,1.64,3.16,2.28c1.2,0.64,2.48,1.04,3.76,1.36c1.28,0.32,2.56,0.56,4.08,0.64c1.52,0.08,3.28,0,4.52,0 c1.24,0,1.96,0.08,2.44,0c0.48-0.08,0.72-0.32,1.04-0.88c0.32-0.56,0.72-1.44,0.96-2.72c0.24-1.28,0.32-2.96,0.52-4.4 c0.2-1.44,0.52-2.64,0.68-3.64c0.16-1,0.16-1.8,0.36-2.68c0.2-0.88,0.6-1.84,1.72-3c1.12-1.16,2.96-2.52,4.64-3.84 c1.68-1.32,3.2-2.6,4.36-3.56c1.16-0.96,1.96-1.6,2.4-2.04c0.44-0.44,0.52-0.68,0.16-0.52c-0.36,0.16-1.16,0.72-2.48,1.6 c-1.32,0.88-3.16,2.08-5.2,3.56c-2.04,1.48-4.28,3.24-6.36,5.04c-2.08,1.8-4,3.64-5.48,4.88c-1.48,1.24-2.52,1.88-3.44,2.24 c-0.92,0.36-1.72,0.44-2.8,0.2c-1.08-0.24-2.44-0.8-3.64-1.72c-1.2-0.92-2.24-2.2-2.84-3.44c-0.6-1.24-0.76-2.44-0.56-3.6 c0.2-1.16,0.76-2.28,1.64-3.76c0.88-1.48,2.08-3.32,3.28-5.12c1.2-1.8,2.4-3.56,3.52-5.2c1.12-1.64,2.16-3.16,2.88-4.24 c0.72-1.08,1.12-1.72,0.96-1.8C347.48,324.12,346.76,324.6,345.6,325.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069378466279951142280000010838785716638499244_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.4799,
    y1: 362.6265,
    x2: 355.32,
    y2: 362.6265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8AC640"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000069378466279951142280000010838785716638499244_)"
    },
    d: " M330.36,357.76c0.56,0.52,1.52,1.8,2.88,2.84c1.36,1.04,3.12,1.84,5.32,2.44c2.2,0.6,4.84,1,7,1.16c2.16,0.16,3.84,0.08,5.36,0 c1.52-0.08,2.88-0.16,3.6,0c0.72,0.16,0.8,0.56,0.8,1.16c0,0.6-0.08,1.4-0.28,1.84c-0.2,0.44-0.52,0.52-2.04,0.56 c-1.52,0.04-4.24,0.04-7.16-0.24c-2.92-0.28-6.04-0.84-8.8-1.96c-2.76-1.12-5.16-2.8-6.36-3.72c-1.2-0.92-1.2-1.08-1.2-1.64 c0-0.56,0-1.52,0.08-2.12C329.64,357.48,329.8,357.24,330.36,357.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136376523099407364900000000270274361730146205_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.5103,
    y1: 365.9525,
    x2: 375.3509,
    y2: 365.9525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    style: {
      stopColor: "#939236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#00807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#007F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#2F6D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#405C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    style: {
      stopColor: "#4B4D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    style: {
      stopColor: "#514091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4465,
    style: {
      stopColor: "#553792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4726,
    style: {
      stopColor: "#563494"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9659,
    style: {
      stopColor: "#DCE11F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000136376523099407364900000000270274361730146205_)"
    },
    d: " M328.76,364.92c-0.4,1.76-1.04,5.2-1.6,9.04c-0.56,3.84-1.04,8.08-1.32,11.16c-0.28,3.08-0.36,5-0.32,6.08 c0.04,1.08,0.2,1.32,2.4,2.08c2.2,0.76,6.44,2.04,8.68,2.64c2.24,0.6,2.48,0.52,2.28,0.2c-0.2-0.32-0.84-0.88-1.8-2.2 c-0.96-1.32-2.24-3.4-2.88-5.56c-0.64-2.16-0.64-4.4-0.08-6.68c0.56-2.28,1.68-4.6,3-6.28c1.32-1.68,2.84-2.72,4.52-3.44 c1.68-0.72,3.52-1.12,5.76-1.04s4.88,0.64,6.84,1.72c1.96,1.08,3.24,2.68,4,3.56c0.76,0.88,1,1.04,1.08-0.36 c0.08-1.4,0-4.36,0.2-7.4c0.2-3.04,0.68-6.16,1.48-9.2c0.8-3.04,1.92-6,3.88-9.28c1.96-3.28,4.76-6.88,6.68-9.08 c1.92-2.2,2.96-3,3.44-3.56c0.48-0.56,0.4-0.88,0.16-1.24c-0.24-0.36-0.64-0.76-1.56-0.4c-0.92,0.36-2.36,1.48-4.44,3.08 c-2.08,1.6-4.8,3.68-6.8,5.24c-2,1.56-3.28,2.6-4.08,3.6c-0.8,1-1.12,1.96-1.44,3.92c-0.32,1.96-0.64,4.92-0.88,6.92 c-0.24,2-0.4,3.04-0.32,3.76c0.08,0.72,0.4,1.12,0.48,2c0.08,0.88-0.08,2.24-0.2,3.08c-0.12,0.84-0.2,1.16-0.6,1.32 c-0.4,0.16-1.12,0.16-3.2,0.12c-2.08-0.04-5.52-0.12-8.64-0.52c-3.12-0.4-5.92-1.12-8-1.92c-2.08-0.8-3.44-1.68-4.32-2.24 c-0.88-0.56-1.28-0.8-1.56-0.88C329.32,363.08,329.16,363.16,328.76,364.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026121554537855855720000002706606438247321232_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.034,
    y1: 438.1963,
    x2: 403.2877,
    y2: 438.1963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384EA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000026121554537855855720000002706606438247321232_)"
    },
    d: " M401.4,394.32c-1.52,1.88-3.84,4.6-7.28,9.52c-3.44,4.92-8,12.04-12.76,19.72c-4.76,7.68-9.72,15.92-14.76,24.16 c-5.04,8.24-10.16,16.48-13.72,21.56c-3.56,5.08-5.56,7-7,8.92c-1.44,1.92-2.32,3.84-3.04,5.04s-1.28,1.68-2.4,1.64 c-1.12-0.04-2.8-0.6-3.68-1.08c-0.88-0.48-0.96-0.88-0.24-1.52c0.72-0.64,2.24-1.52,3.44-2.44c1.2-0.92,2.08-1.88,2.56-3.08 c0.48-1.2,0.56-2.64,0.32-3.96c-0.24-1.32-0.8-2.52-1.72-3.56c-0.92-1.04-2.2-1.92-3.04-2.4c-0.84-0.48-1.24-0.56-1.4-0.92 c-0.16-0.36-0.08-1,0.04-1.76c0.12-0.76,0.28-1.64,0.44-2.68c0.16-1.04,0.32-2.24,0.16-3.2c-0.16-0.96-0.64-1.68-0.52-2.52 c0.12-0.84,0.84-1.8,5.28-8.52c4.44-6.72,12.6-19.2,17.08-25.96c4.48-6.76,5.28-7.8,6.76-9.16c1.48-1.36,3.64-3.04,6.28-4.76 c2.64-1.72,5.76-3.48,8.44-4.88c2.68-1.4,4.92-2.44,7-3.2c2.08-0.76,4-1.24,5.88-2.04c1.88-0.8,3.72-1.92,5.52-3.12 c1.8-1.2,3.56-2.48,4.08-2.6C403.64,391.4,402.92,392.44,401.4,394.32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067952710355091760690000001446600182101286548_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.3062,
    y1: 429.0009,
    x2: 333.9557,
    y2: 429.0009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000067952710355091760690000001446600182101286548_)",
      stroke: "#35459C",
      strokeMiterlimit: 22.9256
    },
    d: " M321.68,404.36c-1,2.56-2.84,8.32-4.96,13.96c-2.12,5.64-4.52,11.16-6.76,16c-2.24,4.84-4.32,9-6.04,12.24 c-1.72,3.24-3.08,5.56-3.48,6.6c-0.4,1.04,0.16,0.8,0.84,0.64c0.68-0.16,1.48-0.24,2.44-0.12c0.96,0.12,2.08,0.44,2.92,0.8 c0.84,0.36,1.4,0.76,1.8,0.88c0.4,0.12,0.64-0.04,1.08-0.64c0.44-0.6,1.08-1.64,1.84-2.68c0.76-1.04,1.64-2.08,2.8-2.8 c1.16-0.72,2.6-1.12,3.76-1.04c1.16,0.08,2.04,0.64,2.92,1.48c0.88,0.84,1.76,1.96,2.32,2.92c0.56,0.96,0.8,1.76,1,2.12 c0.2,0.36,0.36,0.28,0.96,0.08c0.6-0.2,1.64-0.52,2.76-0.68c1.12-0.16,2.32-0.16,3.04-0.2c0.72-0.04,0.96-0.12,0.68-0.4 c-0.28-0.28-1.08-0.76-2.04-1.32c-0.96-0.56-2.08-1.2-2.52-1.84c-0.44-0.64-0.2-1.28,1.16-3.48c1.36-2.2,3.84-5.96,4.96-7.96 c1.12-2,0.88-2.24,0.36-2.28c-0.52-0.04-1.32,0.12-2.28,0.08c-0.96-0.04-2.08-0.28-3-0.92c-0.92-0.64-1.64-1.68-2.12-2.96 c-0.48-1.28-0.72-2.8-0.72-5c0-2.2,0.24-5.08,0.32-7.08c0.08-2,0-3.12-0.12-4.16c-0.12-1.04-0.28-2-0.6-3.24 c-0.32-1.24-0.8-2.76-1.16-4.52c-0.36-1.76-0.6-3.76-0.8-5.08C322.84,402.44,322.68,401.8,321.68,404.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145764564206247215220000014998835544070209727_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.17,
    y1: 526.2136,
    x2: 339.4364,
    y2: 526.2136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FED500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000145764564206247215220000014998835544070209727_)"
    },
    d: " M292.72,481.76c0.2,1.64,0.6,3.96,0.64,6.2c0.04,2.24-0.28,4.4-0.56,6.68c-0.28,2.28-0.52,4.68-0.6,5.84 c-0.08,1.16,0,1.08,0.24,0.88c0.24-0.2,0.64-0.52,1.24-0.92c0.6-0.4,1.4-0.88,2.68-0.96c1.28-0.08,3.04,0.24,8,1.72 c4.96,1.48,13.12,4.12,17.48,5.68c4.36,1.56,4.92,2.04,5.2,2.68c0.28,0.64,0.28,1.44,0.24,2.48c-0.04,1.04-0.12,2.32-2.4,9.28 c-2.28,6.96-6.76,19.6-9.16,26.32c-2.4,6.72-2.72,7.52-3.08,8.04c-0.36,0.52-0.76,0.76-2.24,0.4c-1.48-0.36-4.04-1.32-5.52-1.8 c-1.48-0.48-1.88-0.48-2.08-0.32c-0.2,0.16-0.2,0.48,0.4,1.36c0.6,0.88,1.8,2.32,2.52,3.88c0.72,1.56,0.96,3.24,1.16,5.12 c0.2,1.88,0.36,3.96,0.28,5.88c-0.08,1.92-0.4,3.68,0.24,3.16c0.64-0.52,2.24-3.32,4.76-7.64c2.52-4.32,5.96-10.16,8.92-15.76 c2.96-5.6,5.44-10.96,7.4-16.56c1.96-5.6,3.4-11.44,4.32-16.12c0.92-4.68,1.32-8.2,1.28-10.84c-0.04-2.64-0.52-4.4-0.52-5.8 s0.48-2.44,1.52-4.04c1.04-1.6,2.64-3.76,3.52-5.12c0.88-1.36,1.04-1.92,0.6-2.72c-0.44-0.8-1.48-1.84-2.04-2.2 c-0.56-0.36-0.64-0.04-0.76,0.96c-0.12,1-0.28,2.68-0.68,4c-0.4,1.32-1.04,2.28-2.32,2.72c-1.28,0.44-3.2,0.36-4.8,0.04 c-1.6-0.32-2.88-0.88-3.72-0.64c-0.84,0.24-1.24,1.28-1.8,2.24c-0.56,0.96-1.28,1.84-2.2,2.68c-0.92,0.84-2.04,1.64-3.32,1.88 c-1.28,0.24-2.72-0.08-3.96-0.84c-1.24-0.76-2.28-1.96-3-3.08c-0.72-1.12-1.12-2.16-1.64-2.44c-0.52-0.28-1.16,0.2-2.68,0.32 c-1.52,0.12-3.92-0.12-5.6-0.72c-1.68-0.6-2.64-1.56-3.24-2.96c-0.6-1.4-0.84-3.24-0.68-4.76c0.16-1.52,0.72-2.72,0.68-3.4 c-0.04-0.68-0.68-0.84-1.36-1.16c-0.68-0.32-1.4-0.8-2-1.36c-0.6-0.56-1.08-1.2-1.32-1.04 C292.52,479.16,292.52,480.12,292.72,481.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058564759309450355910000001165130294563846321_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.5669,
    y1: 622.2411,
    x2: 286.95,
    y2: 622.2411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384EA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000058564759309450355910000001165130294563846321_)"
    },
    d: " M286.72,606.2c-0.6,1.12-2.44,3.52-4.4,6.24c-1.96,2.72-4.04,5.76-5.24,8c-1.2,2.24-1.52,3.68-1.72,5.08 c-0.2,1.4-0.28,2.76-0.6,4.24c-0.32,1.48-0.88,3.08-1.76,4.68c-0.88,1.6-2.08,3.2-3,4.64c-0.92,1.44-1.56,2.72-2.32,4.36 c-0.76,1.64-1.64,3.64-2.32,5.2c-0.68,1.56-1.16,2.68-1.64,3.48c-0.48,0.8-0.96,1.28-1.84,1.76c-0.88,0.48-2.16,0.96-3.64,1 c-1.48,0.04-3.16-0.36-6.68-1.44c-3.52-1.08-8.88-2.84-12.92-4.12c-4.04-1.28-6.76-2.08-9-2.68c-2.24-0.6-4-1-6.44-1.44 c-2.44-0.44-5.56-0.92-8.12-1.24c-2.56-0.32-4.56-0.48-7.56-1.44c-3-0.96-7-2.72-11.16-5.16c-4.16-2.44-8.48-5.56-11.96-8.6 c-3.48-3.04-6.12-6-7.88-8.36c-1.76-2.36-2.64-4.12-2.88-5.8c-0.24-1.68,0.16-3.28,0.48-4.52c0.32-1.24,0.56-2.12,1.08-2.8 c0.52-0.68,1.32-1.16,2.28-1.56c0.96-0.4,2.08-0.72,2.96-1.08c0.88-0.36,1.52-0.76,3.16-0.64c1.64,0.12,4.28,0.76,6.88,1.4 c2.6,0.64,5.16,1.28,6.96,1.4c1.8,0.12,2.84-0.28,4-0.44c1.16-0.16,2.44-0.08,5.64-0.16c3.2-0.08,8.32-0.32,12.4-0.68 c4.08-0.36,7.12-0.84,9.88-1.32c2.76-0.48,5.24-0.96,7.32-1.48c2.08-0.52,3.76-1.08,5.08-1.64c1.32-0.56,2.28-1.12,3.24-1.72 c0.96-0.6,1.92-1.24,2.96-2.32c1.04-1.08,2.16-2.6,3.16-4.04c1-1.44,1.88-2.8,2.32-3.24c0.44-0.44,0.44,0.04,0.56,1.28 c0.12,1.24,0.36,3.24,1.24,5.4c0.88,2.16,2.4,4.48,4.28,6.36c1.88,1.88,4.12,3.32,6.6,4.28c2.48,0.96,5.2,1.44,7.76,1.56 c2.56,0.12,4.96-0.12,6.96-0.72c2-0.6,3.6-1.56,4.72-2.12C286.68,605.24,287.32,605.08,286.72,606.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147924351532540135320000006409160955985056391_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.2298,
    y1: 408.608,
    x2: 413.0749,
    y2: 408.608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384EA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000147924351532540135320000006409160955985056391_)"
    },
    d: " M408.64,388.2c-1.24,1.52-3.72,4.96-6.52,8.76c-2.8,3.8-5.92,7.96-9.76,13.6c-3.84,5.64-8.4,12.76-10.52,16.24s-1.8,3.32-1,3.12 c0.8-0.2,2.08-0.44,3.36-0.56c1.28-0.12,2.56-0.12,3.36,0.04c0.8,0.16,1.12,0.48,1.68,0.44c0.56-0.04,1.36-0.44,2.44-0.92 c1.08-0.48,2.44-1.04,3.68-1.24c1.24-0.2,2.36-0.04,3.32,0.32c0.96,0.36,1.76,0.92,2.52,0.92c0.76,0,1.48-0.56,2.4-1.12 c0.92-0.56,2.04-1.12,3.2-1.36c1.16-0.24,2.36-0.16,3.4,0.24c1.04,0.4,1.92,1.12,2.4,1.48c0.48,0.36,0.56,0.36,0.4-0.92 c-0.16-1.28-0.56-3.84-1.08-8.32c-0.52-4.48-1.16-10.88-1.56-15.48c-0.4-4.6-0.56-7.4-0.6-9.76c-0.04-2.36,0.04-4.28,0.08-5.44 C409.88,387.08,409.88,386.68,408.64,388.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083080006616950677180000016890337900102795921_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.77,
    y1: 472.2044,
    x2: 394.3654,
    y2: 472.2044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000083080006616950677180000016890337900102795921_)"
    },
    d: " M374.48,439.56c-1.88,2.56-5.56,8.72-7.32,12.28c-1.76,3.56-1.6,4.52-0.88,7.32c0.72,2.8,2,7.44,3.48,11.72 c1.48,4.28,3.16,8.2,5.36,13c2.2,4.8,4.92,10.48,7.36,14.44c2.44,3.96,4.6,6.2,5.8,7.2c1.2,1,1.44,0.76,1.96-0.28 c0.52-1.04,1.32-2.88,2.2-4.48c0.88-1.6,1.84-2.96,1.92-4c0.08-1.04-0.72-1.76-1.48-2.84c-0.76-1.08-1.48-2.52-1.84-4.04 c-0.36-1.52-0.36-3.12-0.08-4.56s0.84-2.72,1.12-3.44c0.28-0.72,0.28-0.88-0.72-0.84c-1,0.04-3,0.28-4.48,0.44 c-1.48,0.16-2.44,0.24-3.08,0.2c-0.64-0.04-0.96-0.2-1.52-1.8c-0.56-1.6-1.36-4.64-2.36-11.68c-1-7.04-2.2-18.08-2.84-24.12 C376.44,438.04,376.36,437,374.48,439.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015340517384439823420000010194106575881332659_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.849,
    y1: 480.1775,
    x2: 430.04,
    y2: 480.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000015340517384439823420000010194106575881332659_)"
    },
    d: " M407.88,478.96c0.16,0.2,0.96,0.68,1.72,1.68c0.76,1,1.48,2.52,1.88,3.72c0.4,1.2,0.48,2.08,1.04,2.36c0.56,0.28,1.6-0.04,3.2-0.04 c1.6,0,3.76,0.32,5.88,0.72c2.12,0.4,4.2,0.88,5.6,1.4c1.4,0.52,2.12,1.08,2.52,1.28s0.48,0.04-0.08-0.68 c-0.56-0.72-1.76-2-3.04-3.56c-1.28-1.56-2.64-3.4-3.88-5.24c-1.24-1.84-2.36-3.68-3.12-5.44c-0.76-1.76-1.16-3.44-1.44-4.32 c-0.28-0.88-0.44-0.96-1.24,0.4c-0.8,1.36-2.24,4.16-3.2,5.64c-0.96,1.48-1.44,1.64-2.2,1.76c-0.76,0.12-1.8,0.2-2.56,0.2 S407.72,478.76,407.88,478.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039099146450878022750000008733349244646607498_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.1546,
    y1: 583.9496,
    x2: 481.7233,
    y2: 583.9496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384EA1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000039099146450878022750000008733349244646607498_)"
    },
    d: " M442.8,525.8c-0.36,4.8-1.16,12.08-1.44,18.36c-0.28,6.28-0.04,11.56,0.64,16.08c0.68,4.52,1.8,8.28,3.16,11.64 c1.36,3.36,2.96,6.32,4.4,8.8s2.72,4.48,3.36,5.64c0.64,1.16,0.64,1.48,0.4,1.96c-0.24,0.48-0.72,1.12-2.92,2.8 c-2.2,1.68-6.12,4.4-8.36,5.76c-2.24,1.36-2.8,1.36-3.64,0.76c-0.84-0.6-1.96-1.8-3.4-3.8c-1.44-2-3.2-4.8-4.44-6.72 c-1.24-1.92-1.96-2.96-1.72-1.72c0.24,1.24,1.44,4.76,2.52,8.6c1.08,3.84,2.04,8,2.48,11c0.44,3,0.36,4.84-0.12,6.12 c-0.48,1.28-1.36,2-5.24,4.32c-3.88,2.32-10.76,6.24-15.16,9c-4.4,2.76-6.32,4.36-7.76,5.32s-2.4,1.28-4.48,1.56 c-2.08,0.28-5.28,0.52-8.4,0.8c-3.12,0.28-6.16,0.6-8.16,1.48c-2,0.88-2.96,2.32-3.6,3.72c-0.64,1.4-0.96,2.76-0.64,4.32 c0.32,1.56,1.28,3.32,2.8,4.68c1.52,1.36,3.6,2.32,6.92,2.92c3.32,0.6,7.88,0.84,12.96,1c5.08,0.16,10.68,0.24,15.44,0 c4.76-0.24,8.68-0.8,11.72-1.36c3.04-0.56,5.2-1.12,8.12-1.56c2.92-0.44,6.6-0.76,10.44-0.84c3.84-0.08,7.84,0.08,11.4,0.12 s6.68-0.04,9.24-0.32c2.56-0.28,4.56-0.76,6.32-1.4c1.76-0.64,3.28-1.44,4.24-2.52c0.96-1.08,1.36-2.44,1.6-3.56 c0.24-1.12,0.32-2,0.16-2.72c-0.16-0.72-0.56-1.28-0.76-2.16c-0.2-0.88-0.2-2.08-0.52-3.56c-0.32-1.48-0.96-3.24-1.36-5.16 c-0.4-1.92-0.56-4-0.8-6.2c-0.24-2.2-0.56-4.52-1.08-6.2c-0.52-1.68-1.24-2.72-1.88-3.08c-0.64-0.36-1.2-0.04-2.08,0.2 c-0.88,0.24-2.08,0.4-2.84-0.44c-0.76-0.84-1.08-2.68-1.72-6.08c-0.64-3.4-1.6-8.36-2.84-13.56c-1.24-5.2-2.76-10.64-4.2-15.8 c-1.44-5.16-2.8-10.04-4.04-15.12c-1.24-5.08-2.36-10.36-4-16.04c-1.64-5.68-3.8-11.76-5.36-15.88c-1.56-4.12-2.52-6.28-3.28-7.72 c-0.76-1.44-1.32-2.16-1.56-1.36C443.08,518.68,443.16,521,442.8,525.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062180034306606456960000013177589799267570603_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.8314,
    y1: 473.7494,
    x2: 321.6889,
    y2: 473.7494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563494"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116947683777468121920000018305142991533076909_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.3634,
    y1: 473.7494,
    x2: 322.1569,
    y2: 473.7494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000062180034306606456960000013177589799267570603_)",
      stroke: "url(#SVGID_00000116947683777468121920000018305142991533076909_)",
      strokeWidth: 0.9361,
      strokeMiterlimit: 10
    },
    d: " M316.76,478.07c2.71,0,4.93-1.94,4.93-4.32c0-2.38-2.21-4.32-4.93-4.32c-2.71,0-4.93,1.94-4.93,4.32 C311.83,476.13,314.05,478.07,316.76,478.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031895220313213274900000004225692116761363846_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.1292,
    y1: 474.3595,
    x2: 341.3911,
    y2: 474.3595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000031895220313213274900000004225692116761363846_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    cx: 316.76,
    cy: 474.36,
    rx: 24.15,
    ry: 8.99
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011032648156425847050000005637876635692068789_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.2852,
    y1: 474.3598,
    x2: 326.2348,
    y2: 474.3598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000011032648156425847050000005637876635692068789_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    cx: 316.76,
    cy: 474.36,
    rx: 8.99,
    ry: 24.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013192212724936502790000015766575116924710815_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0519,
    y1: 474.3597,
    x2: 335.4681,
    y2: 474.3597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000013192212724936502790000015766575116924710815_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M323.12,468c9.43,9.43,14.23,19.93,10.72,23.44c-3.51,3.51-14.01-1.29-23.44-10.72c-9.43-9.43-14.23-19.93-10.72-23.44 C303.2,453.77,313.69,458.57,323.12,468z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031186439833895989390000003532818940711630264_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0519,
    y1: 474.3597,
    x2: 335.4681,
    y2: 474.3597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1073,
    style: {
      stopColor: "#FFD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#693514"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "url(#SVGID_00000031186439833895989390000003532818940711630264_)",
      strokeWidth: 0.9598,
      strokeMiterlimit: 22.9256
    },
    d: " M323.12,480.72c-9.43,9.43-19.92,14.23-23.44,10.72c-3.51-3.51,1.29-14.01,10.72-23.44c9.43-9.43,19.92-14.23,23.44-10.72 C337.35,460.8,332.55,471.29,323.12,480.72z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedOther);
export default __webpack_public_path__ + "static/media/Mixed (Other).a22ede06d0973d25c86bda64c22cebf2.svg";
export { ForwardRef as ReactComponent };